import React from "react";

export const SideNav = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="16" viewBox="0 0 24 16">
      <g id="menu-right-alt" transform="translate(0)">
        <path
          id="Path_1"
          data-name="Path 1"
          d="M4,6.522A1.511,1.511,0,0,1,5.5,5h21a1.523,1.523,0,0,1,0,3.045H5.5A1.511,1.511,0,0,1,4,6.522Z"
          transform="translate(-4 -5)"
        />
        <path
          id="Path_2"
          data-name="Path 2"
          d="M4,18.522A1.511,1.511,0,0,1,5.5,17h21a1.523,1.523,0,0,1,0,3.045H5.5A1.511,1.511,0,0,1,4,18.522Z"
          transform="translate(-4 -4.045)"
        />
        <path
          id="Path_3"
          data-name="Path 3"
          d="M11.523,11a1.522,1.522,0,0,0,0,3.045H23.7A1.522,1.522,0,0,0,23.7,11Z"
          transform="translate(-1.225 -4.523)"
        />
      </g>
    </svg>
  );
};

export const FilterIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21.297"
      height="19.35"
      viewBox="0 0 21.297 19.35">
      <g id="Group_4203" data-name="Group 4203" transform="translate(0 -1)">
        <path
          id="Path_15265"
          data-name="Path 15265"
          d="M17.51,12.814a3.768,3.768,0,1,1-3.79,3.768A3.782,3.782,0,0,1,17.51,12.814Zm0,1.825a1.942,1.942,0,1,0,1.962,1.942A1.956,1.956,0,0,0,17.51,14.64ZM8.616,15.717a.913.913,0,1,1,0,1.825H.948a.913.913,0,1,1,0-1.825ZM3.788,1A3.768,3.768,0,1,1,0,4.769,3.783,3.783,0,0,1,3.788,1Zm0,1.825A1.942,1.942,0,1,0,5.751,4.769,1.956,1.956,0,0,0,3.788,2.825ZM19.7,3.921a.913.913,0,0,1,0,1.825H12.037a.913.913,0,0,1,0-1.825Z"
          fill="#fff"
          fillRule="evenodd"
        />
      </g>
    </svg>
  );
};

export const AngleLeftIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="90.381"
      height="216.261"
      viewBox="0 0 90.381 216.261">
      <path
        id="X_-_Outline"
        data-name="X - Outline"
        d="M101.893.5h40.986l.147-.236L191.414-77.4l0-4.27.026-48.726L140.8-215.761l-39.739.748,67.173,108.238Z"
        transform="translate(-101.061 215.761)"
        fill="#333"
        opacity="0.19"
      />
    </svg>
  );
};
export const AngleRightIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="90.381"
      height="216.261"
      viewBox="0 0 90.381 216.261">
      <path
        id="X_-_Outline"
        data-name="X - Outline"
        d="M190.61.5H149.624l-.147-.236L101.089-77.4l0-4.27-.026-48.726L151.7-215.761l39.739.748L124.269-106.774Z"
        transform="translate(-101.061 215.761)"
        fill="#333"
        opacity="0.19"
      />
    </svg>
  );
};

export const SimApps = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26">
      <g id="Group_2822" data-name="Group 2822" transform="translate(-1848 -23)">
        <g id="Group_2823" data-name="Group 2823" transform="translate(-2144 -1086)">
          <g id="Group_2826" data-name="Group 2826" transform="translate(-4)">
            <g
              id="Path_14087"
              data-name="Path 14087"
              transform="translate(4016 1129)"
              fill="#636363">
              <path
                d="M 3 5.5 C 1.621500015258789 5.5 0.5 4.378499984741211 0.5 3 C 0.5 1.621500015258789 1.621500015258789 0.5 3 0.5 C 4.378499984741211 0.5 5.5 1.621500015258789 5.5 3 C 5.5 4.378499984741211 4.378499984741211 5.5 3 5.5 Z"
                stroke="none"
              />
              <path
                d="M 3 1 C 1.897200107574463 1 1 1.897200107574463 1 3 C 1 4.102799892425537 1.897200107574463 5 3 5 C 4.102799892425537 5 5 4.102799892425537 5 3 C 5 1.897200107574463 4.102799892425537 1 3 1 M 3 0 C 4.65684986114502 0 6 1.34315013885498 6 3 C 6 4.65684986114502 4.65684986114502 6 3 6 C 1.34315013885498 6 0 4.65684986114502 0 3 C 0 1.34315013885498 1.34315013885498 0 3 0 Z"
                stroke="none"
                fill="#636363"
              />
            </g>
            <g
              id="Path_14088"
              data-name="Path 14088"
              transform="translate(4016 1119)"
              fill="#636363">
              <path
                d="M 3 5.5 C 1.621500015258789 5.5 0.5 4.378499984741211 0.5 3 C 0.5 1.621500015258789 1.621500015258789 0.5 3 0.5 C 4.378499984741211 0.5 5.5 1.621500015258789 5.5 3 C 5.5 4.378499984741211 4.378499984741211 5.5 3 5.5 Z"
                stroke="none"
              />
              <path
                d="M 3 1 C 1.897200107574463 1 1 1.897200107574463 1 3 C 1 4.102799892425537 1.897200107574463 5 3 5 C 4.102799892425537 5 5 4.102799892425537 5 3 C 5 1.897200107574463 4.102799892425537 1 3 1 M 3 0 C 4.65684986114502 0 6 1.34315013885498 6 3 C 6 4.65684986114502 4.65684986114502 6 3 6 C 1.34315013885498 6 0 4.65684986114502 0 3 C 0 1.34315013885498 1.34315013885498 0 3 0 Z"
                stroke="none"
                fill="#636363"
              />
            </g>
            <g
              id="Path_14093"
              data-name="Path 14093"
              transform="translate(4016 1109)"
              fill="#636363">
              <path
                d="M 3 5.5 C 1.621500015258789 5.5 0.5 4.378499984741211 0.5 3 C 0.5 1.621500015258789 1.621500015258789 0.5 3 0.5 C 4.378499984741211 0.5 5.5 1.621500015258789 5.5 3 C 5.5 4.378499984741211 4.378499984741211 5.5 3 5.5 Z"
                stroke="none"
              />
              <path
                d="M 3 1 C 1.897200107574463 1 1 1.897200107574463 1 3 C 1 4.102799892425537 1.897200107574463 5 3 5 C 4.102799892425537 5 5 4.102799892425537 5 3 C 5 1.897200107574463 4.102799892425537 1 3 1 M 3 0 C 4.65684986114502 0 6 1.34315013885498 6 3 C 6 4.65684986114502 4.65684986114502 6 3 6 C 1.34315013885498 6 0 4.65684986114502 0 3 C 0 1.34315013885498 1.34315013885498 0 3 0 Z"
                stroke="none"
                fill="#636363"
              />
            </g>
          </g>
          <g id="Group_2825" data-name="Group 2825" transform="translate(-2)">
            <g
              id="Path_14086"
              data-name="Path 14086"
              transform="translate(4004 1129)"
              fill="#636363">
              <path
                d="M 3 5.5 C 1.621500015258789 5.5 0.5 4.378499984741211 0.5 3 C 0.5 1.621500015258789 1.621500015258789 0.5 3 0.5 C 4.378499984741211 0.5 5.5 1.621500015258789 5.5 3 C 5.5 4.378499984741211 4.378499984741211 5.5 3 5.5 Z"
                stroke="none"
              />
              <path
                d="M 3 1 C 1.897200107574463 1 1 1.897200107574463 1 3 C 1 4.102799892425537 1.897200107574463 5 3 5 C 4.102799892425537 5 5 4.102799892425537 5 3 C 5 1.897200107574463 4.102799892425537 1 3 1 M 3 0 C 4.65684986114502 0 6 1.34315013885498 6 3 C 6 4.65684986114502 4.65684986114502 6 3 6 C 1.34315013885498 6 0 4.65684986114502 0 3 C 0 1.34315013885498 1.34315013885498 0 3 0 Z"
                stroke="none"
                fill="#636363"
              />
            </g>
            <g
              id="Path_14089"
              data-name="Path 14089"
              transform="translate(4004 1119)"
              fill="#636363">
              <path
                d="M 3 5.5 C 1.621500015258789 5.5 0.5 4.378499984741211 0.5 3 C 0.5 1.621500015258789 1.621500015258789 0.5 3 0.5 C 4.378499984741211 0.5 5.5 1.621500015258789 5.5 3 C 5.5 4.378499984741211 4.378499984741211 5.5 3 5.5 Z"
                stroke="none"
              />
              <path
                d="M 3 1 C 1.897200107574463 1 1 1.897200107574463 1 3 C 1 4.102799892425537 1.897200107574463 5 3 5 C 4.102799892425537 5 5 4.102799892425537 5 3 C 5 1.897200107574463 4.102799892425537 1 3 1 M 3 0 C 4.65684986114502 0 6 1.34315013885498 6 3 C 6 4.65684986114502 4.65684986114502 6 3 6 C 1.34315013885498 6 0 4.65684986114502 0 3 C 0 1.34315013885498 1.34315013885498 0 3 0 Z"
                stroke="none"
                fill="#636363"
              />
            </g>
            <g
              id="Path_14092"
              data-name="Path 14092"
              transform="translate(4004 1109)"
              fill="#636363">
              <path
                d="M 3 5.5 C 1.621500015258789 5.5 0.5 4.378499984741211 0.5 3 C 0.5 1.621500015258789 1.621500015258789 0.5 3 0.5 C 4.378499984741211 0.5 5.5 1.621500015258789 5.5 3 C 5.5 4.378499984741211 4.378499984741211 5.5 3 5.5 Z"
                stroke="none"
              />
              <path
                d="M 3 1 C 1.897200107574463 1 1 1.897200107574463 1 3 C 1 4.102799892425537 1.897200107574463 5 3 5 C 4.102799892425537 5 5 4.102799892425537 5 3 C 5 1.897200107574463 4.102799892425537 1 3 1 M 3 0 C 4.65684986114502 0 6 1.34315013885498 6 3 C 6 4.65684986114502 4.65684986114502 6 3 6 C 1.34315013885498 6 0 4.65684986114502 0 3 C 0 1.34315013885498 1.34315013885498 0 3 0 Z"
                stroke="none"
                fill="#636363"
              />
            </g>
          </g>
          <g id="Group_2824" data-name="Group 2824">
            <g
              id="Path_14085"
              data-name="Path 14085"
              transform="translate(3992 1129)"
              fill="#636363">
              <path
                d="M 3 5.5 C 1.621500015258789 5.5 0.5 4.378499984741211 0.5 3 C 0.5 1.621500015258789 1.621500015258789 0.5 3 0.5 C 4.378499984741211 0.5 5.5 1.621500015258789 5.5 3 C 5.5 4.378499984741211 4.378499984741211 5.5 3 5.5 Z"
                stroke="none"
              />
              <path
                d="M 3 1 C 1.897200107574463 1 1 1.897200107574463 1 3 C 1 4.102799892425537 1.897200107574463 5 3 5 C 4.102799892425537 5 5 4.102799892425537 5 3 C 5 1.897200107574463 4.102799892425537 1 3 1 M 3 0 C 4.65684986114502 0 6 1.34315013885498 6 3 C 6 4.65684986114502 4.65684986114502 6 3 6 C 1.34315013885498 6 0 4.65684986114502 0 3 C 0 1.34315013885498 1.34315013885498 0 3 0 Z"
                stroke="none"
                fill="#636363"
              />
            </g>
            <g
              id="Path_14090"
              data-name="Path 14090"
              transform="translate(3992 1119)"
              fill="#636363">
              <path
                d="M 3 5.5 C 1.621500015258789 5.5 0.5 4.378499984741211 0.5 3 C 0.5 1.621500015258789 1.621500015258789 0.5 3 0.5 C 4.378499984741211 0.5 5.5 1.621500015258789 5.5 3 C 5.5 4.378499984741211 4.378499984741211 5.5 3 5.5 Z"
                stroke="none"
              />
              <path
                d="M 3 1 C 1.897200107574463 1 1 1.897200107574463 1 3 C 1 4.102799892425537 1.897200107574463 5 3 5 C 4.102799892425537 5 5 4.102799892425537 5 3 C 5 1.897200107574463 4.102799892425537 1 3 1 M 3 0 C 4.65684986114502 0 6 1.34315013885498 6 3 C 6 4.65684986114502 4.65684986114502 6 3 6 C 1.34315013885498 6 0 4.65684986114502 0 3 C 0 1.34315013885498 1.34315013885498 0 3 0 Z"
                stroke="none"
                fill="#636363"
              />
            </g>
            <g
              id="Path_14091"
              data-name="Path 14091"
              transform="translate(3992 1109)"
              fill="#636363">
              <path
                d="M 3 5.5 C 1.621500015258789 5.5 0.5 4.378499984741211 0.5 3 C 0.5 1.621500015258789 1.621500015258789 0.5 3 0.5 C 4.378499984741211 0.5 5.5 1.621500015258789 5.5 3 C 5.5 4.378499984741211 4.378499984741211 5.5 3 5.5 Z"
                stroke="none"
              />
              <path
                d="M 3 1 C 1.897200107574463 1 1 1.897200107574463 1 3 C 1 4.102799892425537 1.897200107574463 5 3 5 C 4.102799892425537 5 5 4.102799892425537 5 3 C 5 1.897200107574463 4.102799892425537 1 3 1 M 3 0 C 4.65684986114502 0 6 1.34315013885498 6 3 C 6 4.65684986114502 4.65684986114502 6 3 6 C 1.34315013885498 6 0 4.65684986114502 0 3 C 0 1.34315013885498 1.34315013885498 0 3 0 Z"
                stroke="none"
                fill="#636363"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export const DashBoardIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23.845"
      height="23.845"
      viewBox="0 0 23.845 23.845">
      <g id="dashboard" transform="translate(0.15 0.15)">
        <path
          id="Path_8284"
          data-name="Path 8284"
          d="M24,21h1.512v3.78H24Z"
          transform="translate(-7.722 -6.976)"
          fill="#fff"
          stroke="#fff"
          strokeWidth="0.3"
        />
        <path
          id="Path_8285"
          data-name="Path 8285"
          d="M20,16h1.512v7.56H20Z"
          transform="translate(-6.682 -5.724)"
          fill="#fff"
          stroke="#fff"
          strokeWidth="0.3"
        />
        <path
          id="Path_8286"
          data-name="Path 8286"
          d="M9.78,23.56A3.784,3.784,0,0,1,6,19.78H7.512A2.268,2.268,0,1,0,9.78,17.512V16a3.78,3.78,0,0,1,0,7.56Z"
          transform="translate(-2.976 -5.724)"
          fill="#fff"
          stroke="#fff"
          strokeWidth="0.3"
        />
        <path
          id="Path_8287"
          data-name="Path 8287"
          d="M23.863,2H3.682A1.683,1.683,0,0,0,2,3.682V23.863a1.683,1.683,0,0,0,1.682,1.682H23.863a1.684,1.684,0,0,0,1.682-1.682V3.682A1.683,1.683,0,0,0,23.863,2Zm0,7.568H12.091V3.682H23.863ZM10.409,3.682V9.568H3.682V3.682ZM3.682,23.863V11.25H23.863l0,12.613Z"
          transform="translate(-2 -2)"
          fill="#fff"
          stroke="#fff"
          strokeWidth="0.3"
        />
      </g>{" "}
    </svg>
  );
};

export const MyDashBoardIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23.223"
      height="23.223"
      viewBox="0 0 23.223 23.223">
      <path
        id="dashboard_FILL0_wght400_GRAD0_opsz24"
        d="M132.9-832.259V-840h10.321v7.741ZM120-827.1V-840h10.321v12.9Zm12.9,10.321v-12.9h10.321v12.9Zm-12.9,0v-7.741h10.321v7.741Zm1.58-11.9h7.161v-9.741H121.58Zm12.9,10.321h7.161V-828.1h-7.161Zm0-15.482h7.161v-4.58h-7.161Zm-12.9,15.482h7.161v-4.58H121.58Z"
        transform="translate(-120 840)"
        fill="#333"
      />
    </svg>
  );
};

export const TeamManagementIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22.997"
      height="24.23"
      viewBox="0 0 22.997 24.23">
      <path
        id="Team_Management"
        data-name="Team Management"
        d="M25.1,19.481h-.827a4.157,4.157,0,0,0-.55-1.317l.586-.587A.923.923,0,0,0,23,16.271l-.586.587a4.169,4.169,0,0,0-1.317-.55v-.827a.923.923,0,0,0-1.846,0v.827a4.169,4.169,0,0,0-1.317.55l-.586-.587a.923.923,0,0,0-1.306,1.306l.586.587a4.169,4.169,0,0,0-.55,1.317H15.25a.923.923,0,0,0,0,1.846h.827a4.157,4.157,0,0,0,.55,1.317l-.586.587a.923.923,0,1,0,1.3,1.306l.586-.587a4.169,4.169,0,0,0,1.317.55v.827a.923.923,0,0,0,1.846,0V24.5a4.169,4.169,0,0,0,1.317-.55l.586.587a.923.923,0,0,0,1.3-1.306l-.586-.587a4.169,4.169,0,0,0,.55-1.317h.827a.923.923,0,0,0,0-1.846Zm-3.262,2.585a.279.279,0,0,0-.016.025,2.345,2.345,0,0,1-3.289,0,.279.279,0,0,1-.016-.025c-.006-.007-.017-.01-.025-.016a2.345,2.345,0,0,1,0-3.289c.007-.007.017-.009.025-.016a.278.278,0,0,0,.016-.025,2.345,2.345,0,0,1,3.289,0,.279.279,0,0,1,.016.025c.006.007.017.01.025.016a2.345,2.345,0,0,1,0,3.289C21.852,22.057,21.842,22.058,21.835,22.065Zm-7.815-8.123A5.846,5.846,0,1,1,19.865,8.1,5.853,5.853,0,0,1,14.019,13.942Zm0-9.846a4,4,0,1,0,4,4A4,4,0,0,0,14.019,4.1Zm-.345,21.231a.923.923,0,0,0-.923-.923H6.635A1.541,1.541,0,0,1,5.1,22.865a5.237,5.237,0,0,1,5.231-5.231h2.462a.923.923,0,0,0,0-1.846H10.327A7.085,7.085,0,0,0,3.25,22.865,3.387,3.387,0,0,0,6.635,26.25h6.117a.923.923,0,0,0,.923-.923Z"
        transform="translate(-3.135 -2.135)"
        fill="#333"
        stroke="#333"
        strokeWidth="0.23"
      />
    </svg>
  );
};
export const ContentManagementIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23.576"
      height="23.576"
      viewBox="0 0 23.576 23.576">
      <path
        id="Leaderboard"
        d="M3,6.879A3.879,3.879,0,0,1,6.879,3H22.4a3.879,3.879,0,0,1,3.879,3.879V22.4A3.879,3.879,0,0,1,22.4,26.276H6.879A3.879,3.879,0,0,1,3,22.4ZM6.879,5.586A1.293,1.293,0,0,0,5.586,6.879V22.4A1.293,1.293,0,0,0,6.879,23.69H22.4A1.293,1.293,0,0,0,23.69,22.4V6.879A1.293,1.293,0,0,0,22.4,5.586Zm7.759,2.586a1.293,1.293,0,0,1,1.293,1.293V19.811a1.293,1.293,0,1,1-2.586,0V9.466A1.293,1.293,0,0,1,14.638,8.173ZM9.466,12.052a1.293,1.293,0,0,1,1.293,1.293v6.466a1.293,1.293,0,1,1-2.586,0V13.345A1.293,1.293,0,0,1,9.466,12.052Zm10.345,3.879A1.293,1.293,0,0,1,21.1,17.224v2.586a1.293,1.293,0,1,1-2.586,0V17.224A1.293,1.293,0,0,1,19.811,15.931Z"
        transform="translate(-2.85 -2.85)"
        fill="#333"
        stroke="#fff"
        strokeWidth="0.3"
      />
    </svg>
  );
};
export const SupportSettingIcon = () => {
  return (
    <svg
      id="work-alt"
      xmlns="http://www.w3.org/2000/svg"
      width="16.856"
      height="24.178"
      viewBox="0 0 16.856 24.178">
      <path
        id="courses"
        d="M21.171,26.178H7.686A1.708,1.708,0,0,1,6,24.451V3.727A1.708,1.708,0,0,1,7.686,2H21.171a1.708,1.708,0,0,1,1.686,1.727V18.076l-4.214-2.159-4.214,2.159V3.727H7.686V24.451H21.171V21h1.686v3.454A1.709,1.709,0,0,1,21.171,26.178ZM18.642,13.987l2.528,1.3V3.727H16.114V15.282Z"
        transform="translate(-6 -2)"
        fill="#333"
      />
    </svg>
  );
};
export const CourseIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="work-alt"
      width="16.856"
      height="24.178"
      viewBox="0 0 16.856 24.178">
      <path
        id="courses"
        d="M21.171,26.178H7.686A1.708,1.708,0,0,1,6,24.451V3.727A1.708,1.708,0,0,1,7.686,2H21.171a1.708,1.708,0,0,1,1.686,1.727V18.076l-4.214-2.159-4.214,2.159V3.727H7.686V24.451H21.171V21h1.686v3.454A1.709,1.709,0,0,1,21.171,26.178ZM18.642,13.987l2.528,1.3V3.727H16.114V15.282Z"
        transform="translate(-6 -2)"
        fill="#333"
      />
    </svg>
  );
};

export const SupportIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22.505"
      height="22.505"
      viewBox="0 0 22.505 22.505">
      <g id="noun-question-5752545" transform="translate(-0.25 -0.25)">
        <path
          id="Path_14419"
          data-name="Path 14419"
          d="M1.929,18.468a.536.536,0,0,1-.437-.846A5.852,5.852,0,0,0,2.541,15c.016-.12.028-.24.036-.358a8.527,8.527,0,1,1,3.036,2.069,7.018,7.018,0,0,1-3.6,1.747A.56.56,0,0,1,1.929,18.468ZM8.788,1.322A7.466,7.466,0,0,0,3.5,14.063a.537.537,0,0,1,.156.394c-.007.217-.025.452-.057.688a6.778,6.778,0,0,1-.56,1.928,5.8,5.8,0,0,0,1.942-1.24l.129-.129a.537.537,0,0,1,.6-.11,7.374,7.374,0,0,0,3.071.66,7.466,7.466,0,1,0,0-14.932Z"
          transform="translate(0)"
          fill="#333"
        />
        <path
          id="Path_14420"
          data-name="Path 14420"
          d="M24.269,25.008A.546.546,0,0,1,24.177,25a7.035,7.035,0,0,1-3.592-1.745A8.539,8.539,0,0,1,11.6,21.578a.536.536,0,0,1,.73-.785,7.464,7.464,0,0,0,8.152,1.341.537.537,0,0,1,.6.111l.135.136a5.789,5.789,0,0,0,1.935,1.231,6.892,6.892,0,0,1-.56-1.924c-.031-.234-.047-.473-.054-.69a.537.537,0,0,1,.155-.4A7.458,7.458,0,0,0,21.55,9.122a.536.536,0,1,1,.593-.892,8.529,8.529,0,0,1,1.479,12.954c.008.119.018.24.034.36A5.908,5.908,0,0,0,24.7,24.16a.535.535,0,0,1-.435.848Z"
          transform="translate(-3.192 -2.253)"
          fill="#333"
        />
        <path
          id="Path_14421"
          data-name="Path 14421"
          d="M10.886,12.725a.536.536,0,0,1-.536-.536V11.94a2.542,2.542,0,0,1,1.275-2.27,1.931,1.931,0,0,0,.927-2.137A1.78,1.78,0,0,0,11.29,6.172a1.614,1.614,0,0,0-1.407.3,1.93,1.93,0,0,0-.712,1.513.536.536,0,1,1-1.072,0A3.007,3.007,0,0,1,9.221,5.632a2.7,2.7,0,0,1,2.322-.5A2.834,2.834,0,0,1,13.6,7.309a3,3,0,0,1-1.479,3.311,1.465,1.465,0,0,0-.7,1.319v.249a.536.536,0,0,1-.536.536Z"
          transform="translate(-2.242 -1.371)"
          fill="#333"
        />
        <circle
          id="Ellipse_649"
          data-name="Ellipse 649"
          cx="0.75"
          cy="0.75"
          r="0.75"
          transform="translate(7.894 12.447)"
          fill="#333"
        />
      </g>
    </svg>
  );
};

export const CancelIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      className="bi bi-x"
      viewBox="0 0 16 16">
      <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
    </svg>
  );
};

export const EditIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
      <g id="Group_3141" data-name="Group 3141" transform="translate(-24.2 -24.2)">
        <path
          id="Path_14272"
          data-name="Path 14272"
          d="M29.781,48.2H42.619A5.6,5.6,0,0,0,48.2,42.619h0V38.991a.93.93,0,0,0-1.86,0v3.628a3.732,3.732,0,0,1-3.721,3.721H29.781a3.732,3.732,0,0,1-3.721-3.721V29.781a3.732,3.732,0,0,1,3.721-3.721h3.628a.93.93,0,0,0,0-1.86H29.781A5.6,5.6,0,0,0,24.2,29.781V42.619A5.6,5.6,0,0,0,29.781,48.2Z"
          fill="#333"
        />
        <path
          id="Path_14273"
          data-name="Path 14273"
          d="M50.482,25.677l-9.488,9.488a.9.9,0,0,0-.233.419l-1.3,4.651A.93.93,0,0,0,40.11,41.4a.951.951,0,0,0,.512,0l4.651-1.3a1.886,1.886,0,0,0,.419-.233l9.535-9.488a3.313,3.313,0,0,0,0-4.7,3.369,3.369,0,0,0-4.744,0ZM41.645,39.165l.465-1.581,1.163,1.163Zm12.186-10.14L45.04,37.816,42.994,35.77l8.791-8.791a1.462,1.462,0,0,1,2.047.14A1.478,1.478,0,0,1,53.831,29.026Z"
          transform="translate(-8.142 -0.267)"
          fill="#333"
        />
      </g>
    </svg>
  );
};

export const DeleteIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20.24" height="24" viewBox="0 0 20.24 24">
      <g id="Group_4462" data-name="Group 4462" transform="translate(-108.999 -172.003)">
        <g id="trash-can-10416" transform="translate(108.999 172.003)">
          <path
            id="Path_156"
            data-name="Path 156"
            d="M48.776,52.948H38.467a2.343,2.343,0,0,1-2.317-2.228L35.123,32.83a.81.81,0,0,1,.212-.6.777.777,0,0,1,.571-.251h15.43a.779.779,0,0,1,.571.251.812.812,0,0,1,.213.6L51.093,50.72A2.343,2.343,0,0,1,48.776,52.948ZM36.738,33.583l.979,17.043a.759.759,0,0,0,.75.722H48.776a.758.758,0,0,0,.75-.721l.979-17.044Z"
            transform="translate(-33.502 -28.948)"
            fill="#ca353b"
          />
          <path
            id="Path_157"
            data-name="Path 157"
            d="M37.169,33.581H18.5a.8.8,0,0,1,0-1.6H37.17a.8.8,0,0,1,0,1.6Z"
            transform="translate(-17.714 -28.946)"
            fill="#ca353b"
          />
          <path
            id="Path_158"
            data-name="Path 158"
            d="M87.407,4.635H80.226a.792.792,0,0,1-.785-.8V2.344A2.324,2.324,0,0,1,81.74,0h4.153a2.324,2.324,0,0,1,2.3,2.344V3.835A.792.792,0,0,1,87.407,4.635Zm-6.4-1.6h5.611V2.344a.737.737,0,0,0-.729-.744H81.74a.737.737,0,0,0-.729.744v.691Z"
            transform="translate(-73.697)"
            fill="#ca353b"
          />
          <path
            id="Path_159"
            data-name="Path 159"
            d="M156.254,88.019h-.047a.8.8,0,0,1-.737-.846l.647-11.265a.786.786,0,0,1,.829-.752.8.8,0,0,1,.737.845l-.647,11.265A.791.791,0,0,1,156.254,88.019Z"
            transform="translate(-142.648 -68.021)"
            fill="#ca353b"
          />
          <path
            id="Path_160"
            data-name="Path 160"
            d="M75.049,88.02a.791.791,0,0,1-.782-.753L73.62,76a.785.785,0,1,1,1.566-.094l.647,11.265a.8.8,0,0,1-.737.846Z"
            transform="translate(-68.416 -68.022)"
            fill="#ca353b"
          />
          <path
            id="Path_161"
            data-name="Path 161"
            d="M118.8,88.024a.792.792,0,0,1-.785-.8V75.959a.785.785,0,1,1,1.569,0V87.224A.792.792,0,0,1,118.8,88.024Z"
            transform="translate(-108.685 -68.026)"
            fill="#ca353b"
          />
        </g>
      </g>
    </svg>
  );
};

export const PDFDownloadIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20.441"
      height="28.87"
      viewBox="0 0 20.441 28.87">
      <g id="noun-pdf-3836262" transform="translate(0.25 0.254)">
        <g id="Group_2726" data-name="Group 2726" transform="translate(0 0)">
          <path
            id="Path_13738"
            data-name="Path 13738"
            d="M35.108,41.181a1.251,1.251,0,0,1-.967-.465,1.277,1.277,0,0,1-.036-1.754,4.583,4.583,0,0,1,2.076-1.217,10.7,10.7,0,0,1,1.146-.322,14.655,14.655,0,0,0,.716-1.5,14.31,14.31,0,0,0,.537-1.432,6.269,6.269,0,0,1-1.074-3.007,1.318,1.318,0,0,1,1.217-1.4h0a1.234,1.234,0,0,1,1.4.9,6.522,6.522,0,0,1-.322,3.329,11.3,11.3,0,0,0,1,1.4c.322.394.609.752.931,1.11a7.171,7.171,0,0,1,3.15.5,1.269,1.269,0,0,1,.716,1.539,1.286,1.286,0,0,1-1.5.967,5.664,5.664,0,0,1-2.828-1.862,18.094,18.094,0,0,0-1.862.179c-.465.072-.931.143-1.36.251a6.9,6.9,0,0,1-.465.752,6.1,6.1,0,0,1-1.718,1.826A1.5,1.5,0,0,1,35.108,41.181Zm1.4-2.363a3.884,3.884,0,0,0-1.575.859c-.107.107-.107.179.036.358.072.072.107.143.394,0A4.765,4.765,0,0,0,36.5,38.818Zm6.372-.823a2.885,2.885,0,0,0,1.36.788c.143.036.215.036.322-.215.036-.072.036-.107-.179-.251A4.509,4.509,0,0,0,42.876,37.994Zm-3.508-2.327c-.107.286-.215.537-.286.716-.107.286-.251.537-.358.788a2.763,2.763,0,0,1,.537-.072c.358-.036.716-.107,1.074-.107-.179-.215-.322-.394-.394-.5C39.8,36.276,39.583,35.989,39.368,35.667Zm-.5-4.475c-.143.036-.251.036-.251.322a3.759,3.759,0,0,0,.43,1.468,3.638,3.638,0,0,0,.072-1.611c-.072-.179-.107-.179-.251-.179Z"
            transform="translate(-29.63 -23.053)"
            fill="#fff"
          />
          <g id="Group_2725" data-name="Group 2725" transform="translate(5.084 20.133)">
            <path
              id="Path_13739"
              data-name="Path 13739"
              d="M36.4,67.165a.432.432,0,0,1,.465-.465h1.181a1.378,1.378,0,0,1,1.468,1.432,1.334,1.334,0,0,1-1.432,1.432h-.716v.9a.461.461,0,0,1-.465.5.443.443,0,0,1-.465-.5V67.165Zm.967,1.539h.5a.607.607,0,0,0,.644-.573c0-.394-.251-.573-.644-.573h-.5Z"
              transform="translate(-36.4 -66.7)"
              fill="#fff"
            />
            <path
              id="Path_13740"
              data-name="Path 13740"
              d="M46.5,67.165a.432.432,0,0,1,.465-.465h1.146a2.117,2.117,0,0,1,0,4.224H46.965a.451.451,0,0,1-.465-.465Zm.967,2.864h.5c.752,0,1.11-.5,1.11-1.253,0-.716-.358-1.181-1.074-1.181h-.537Z"
              transform="translate(-42.884 -66.7)"
              fill="#fff"
            />
            <path
              id="Path_13741"
              data-name="Path 13741"
              d="M58.1,67.165a.432.432,0,0,1,.465-.465h1.468a.424.424,0,0,1,.465.43c0,.286-.179.43-.465.43h-1v.752h.859a.424.424,0,0,1,.465.43c0,.286-.179.43-.465.43h-.859v1.217a.461.461,0,0,1-.465.5.443.443,0,0,1-.465-.5Z"
              transform="translate(-50.331 -66.7)"
              fill="#fff"
            />
          </g>
          <path
            id="Path_13742"
            data-name="Path 13742"
            d="M41.568,17.923a.551.551,0,0,0-.537.537V36.575a1.115,1.115,0,0,1-1.11,1.11H24.384a1.115,1.115,0,0,1-1.11-1.11V12.661a1.115,1.115,0,0,1,1.11-1.11H35.7V14.88a1.987,1.987,0,0,0,1.969,1.969h3.866a.561.561,0,0,0,.5-.322.64.64,0,0,0-.107-.609l-5.3-5.3a.491.491,0,0,0-.465-.143H24.42A2.231,2.231,0,0,0,22.2,12.7V36.611a2.231,2.231,0,0,0,2.22,2.22h15.5a2.231,2.231,0,0,0,2.22-2.22V18.46A.583.583,0,0,0,41.568,17.923Zm-3.9-2.184a.886.886,0,0,1-.9-.9V12.267l3.473,3.473Z"
            transform="translate(-22.2 -10.464)"
            fill="#fff"
            stroke="#fff"
            stroke-width="0.5"
          />
        </g>
      </g>
    </svg>
  );
};

export const EXLDownloadIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30.037"
      height="28.37"
      viewBox="0 0 30.037 28.37">
      <g id="noun-excel-1194546" transform="translate(-0.001)">
        <path
          id="Path_13743"
          data-name="Path 13743"
          d="M35.51,46.788V22.41H33.541c-5.056.913-10.1,1.758-15.171,2.635V48.1c4.992.881,10.047,1.763,15.071,2.676H35.5V46.788Zm-7.435-5.06a38.887,38.887,0,0,1-1.653-4.138c-.457,1.338-1.087,2.6-1.6,3.909-.722,0-1.443-.041-2.165-.069.845-1.658,1.662-3.329,2.535-4.973-.74-1.7-1.557-3.361-2.32-5.046l2.183-.123c.489,1.288,1.028,2.562,1.434,3.882.457-1.4,1.082-2.74,1.64-4.074q1.119-.078,2.242-.137-1.315,2.7-2.653,5.421c.913,1.827,1.827,3.676,2.74,5.521C29.66,41.838,28.869,41.788,28.075,41.728Z"
          transform="translate(-18.369 -22.41)"
          fill="#fff"
        />
        <path
          id="Path_13744"
          data-name="Path 13744"
          d="M57.72,29.33v1.749h3.494v2.58H57.72v1.416h3.494v2.58H57.72v1.416h3.494v2.576H57.72v1.416h3.494V45.62H57.72v1.5h3.494v2.5H57.72v1.749H69.786V29.33Zm9.4,20.3H62.045v-2.5h5.078Zm0-4H62.045v-2.58h5.078Zm0-4H62.045V39.067h5.078Zm0-4H62.045V35.071h5.078Zm0-4H62.045V31.079h5.078Z"
          transform="translate(-39.748 -26.17)"
          fill="#fff"
        />
      </g>
    </svg>
  );
};

export const MyCertificateIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22.615"
      height="21.799"
      viewBox="0 0 22.615 21.799">
      <g id="Group_5361" data-name="Group 5361" transform="translate(-10.94 -12.35)">
        <path
          id="Path_16443"
          data-name="Path 16443"
          d="M65.461,53.662a1.9,1.9,0,1,0-1.9-1.9A1.9,1.9,0,0,0,65.461,53.662Zm0-2.934a.428.428,0,1,1,0-.006Z"
          transform="translate(-37.395 -26.657)"
          fill="#333"
        />
        <path
          id="Path_16444"
          data-name="Path 16444"
          d="M11.374,29.458H25.392l-.949,3.55a.434.434,0,0,0,.616.5l1-.515.61.958a.428.428,0,0,0,.365.2.437.437,0,0,0,.411-.327l.637-2.187.579,2.187a.437.437,0,0,0,.42.321.431.431,0,0,0,.373-.194L30.068,33l1,.515a.437.437,0,0,0,.619-.492l-.885-3.568h2.315a.434.434,0,0,0,.434-.434V12.784a.434.434,0,0,0-.434-.434H11.374a.434.434,0,0,0-.434.434V29.03a.434.434,0,0,0,.434.428Zm14.068-4.051L25,25.118l.44-.289a.868.868,0,0,0,.324-1l-.176-.5h.529a.868.868,0,0,0,.848-.616l.153-.509.422.324a.868.868,0,0,0,1.047,0l.422-.324.15.509a.868.868,0,0,0,.851.616h.529l-.176.5a.868.868,0,0,0,.324,1l.44.289-.44.289a.868.868,0,0,0-.324,1l.176.5-.529-.014H29.99a.868.868,0,0,0-.828.619l-.148.509L28.59,27.7a.868.868,0,0,0-1.047,0l-.422.324-.153-.509a.868.868,0,0,0-.825-.619h-.023l-.529.014.176-.5a.868.868,0,0,0-.324-1.01Zm1.447,7.265-.307-.483a.434.434,0,0,0-.561-.15l-.483.246.978-3.651a.868.868,0,0,0,1.128.069l.425-.324.043.032Zm3.226-.634a.431.431,0,0,0-.561.15l-.289.454-.706-2.636.327-1.137a.868.868,0,0,0,.81-.312l.937,3.738ZM11.808,13.218H32.675V28.59H30.592l-.205-.828h.142a.868.868,0,0,0,.836-1.157l-.179-.506.443-.289a.868.868,0,0,0,0-1.424l-.443-.289.179-.506a.868.868,0,0,0-.836-1.157l-.535.014-.15-.515a.846.846,0,0,0-1.351-.425l-.425.324-.425-.324a.868.868,0,0,0-1.348.422l-.153.515L25.6,22.43a.868.868,0,0,0-.833,1.157l.176.506-.44.289a.868.868,0,0,0,0,1.424l.44.289-.176.506A.868.868,0,0,0,25.6,27.76h.249l-.223.83H11.808Z"
          transform="translate(0)"
          fill="#333"
        />
        <path
          id="Path_16445"
          data-name="Path 16445"
          d="M35.911,20.711v-2.5a.434.434,0,0,0-.434-.434H16.994a.434.434,0,0,0-.434.434v2.5a.434.434,0,0,0,.434.434H35.477A.434.434,0,0,0,35.911,20.711Zm-.868-.434H17.428V18.648H35.043Z"
          transform="translate(-3.994 -3.859)"
          fill="#333"
        />
        <path
          id="Path_16446"
          data-name="Path 16446"
          d="M30.439,32.21H20.874a.434.434,0,0,0,0,.868h9.565a.434.434,0,1,0,0-.868Z"
          transform="translate(-6.751 -14.114)"
          fill="#333"
        />
        <path
          id="Path_16447"
          data-name="Path 16447"
          d="M30.439,38.75H20.874a.434.434,0,0,0,0,.868h9.565a.434.434,0,0,0,0-.868Z"
          transform="translate(-6.751 -18.762)"
          fill="#333"
        />
        <path
          id="Path_16448"
          data-name="Path 16448"
          d="M30.439,45.29H20.874a.434.434,0,1,0,0,.868h9.565a.434.434,0,1,0,0-.868Z"
          transform="translate(-6.751 -23.409)"
          fill="#333"
        />
        <path
          id="Path_16449"
          data-name="Path 16449"
          d="M34.178,51.83H29.754a.434.434,0,1,0,0,.868h4.424a.434.434,0,0,0,0-.868Z"
          transform="translate(-13.062 -28.057)"
          fill="#333"
        />
      </g>
    </svg>
  );
};

export const Previewbg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="243" height="62" viewBox="0 0 243 62">
      <defs>
        <filter id="Path_16560" x="0" y="0" width="243" height="62" filterUnits="userSpaceOnUse">
          <feOffset dy="3" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="3" result="blur" />
          <feFlood floodOpacity="0.341" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g transform="matrix(1, 0, 0, 1, 0, 0)" filter="url(#Path_16560)">
        <path
          id="Path_16560-2"
          data-name="Path 16560"
          d="M0,0H225L214,32c-1.857,6.929-5.373,12-12,12H23c-6.627,0-10.012-6.139-12-12Z"
          transform="translate(9 6)"
          fill="#ca373c"
        />
      </g>
    </svg>
  );
};

// 22/01/2024
export const CheckIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 31.102 31.102">
      <path
        id="Path_17647"
        data-name="Path 17647"
        d="M39.734,27.884A3.6,3.6,0,0,0,41.1,25.551a3.582,3.582,0,0,0-1.368-2.326A3.563,3.563,0,0,1,38.794,22,3.663,3.663,0,0,1,39,20.413a3.517,3.517,0,0,0,.019-2.637,3.517,3.517,0,0,0-2.308-1.306,3.634,3.634,0,0,1-1.468-.61,3.654,3.654,0,0,1-.6-1.462,3.528,3.528,0,0,0-1.306-2.308,3.459,3.459,0,0,0-2.637.019,3.7,3.7,0,0,1-1.6.205,3.773,3.773,0,0,1-1.213-.945A3.61,3.61,0,0,0,25.551,10a3.582,3.582,0,0,0-2.326,1.369A3.674,3.674,0,0,1,22,12.314a3.663,3.663,0,0,1-1.586-.205,3.459,3.459,0,0,0-2.637-.019A3.5,3.5,0,0,0,16.469,14.4a3.724,3.724,0,0,1-.61,1.468,3.654,3.654,0,0,1-1.462.6,3.506,3.506,0,0,0-2.308,1.3,3.475,3.475,0,0,0,.019,2.644,3.777,3.777,0,0,1,.205,1.592,3.721,3.721,0,0,1-.945,1.219A3.582,3.582,0,0,0,10,25.551a3.6,3.6,0,0,0,1.368,2.333,3.721,3.721,0,0,1,.945,1.219,3.788,3.788,0,0,1-.205,1.592,3.459,3.459,0,0,0-.019,2.637A3.513,3.513,0,0,0,14.4,34.639a3.635,3.635,0,0,1,1.468.61,3.745,3.745,0,0,1,.6,1.462,3.535,3.535,0,0,0,1.3,2.308A3.533,3.533,0,0,0,20.413,39a3.68,3.68,0,0,1,1.592-.205,3.609,3.609,0,0,1,1.219.939A3.582,3.582,0,0,0,25.551,41.1a3.61,3.61,0,0,0,2.333-1.369,3.609,3.609,0,0,1,1.219-.939A3.691,3.691,0,0,1,30.7,39a3.517,3.517,0,0,0,2.637.019,3.543,3.543,0,0,0,1.306-2.308,3.634,3.634,0,0,1,.61-1.468,3.653,3.653,0,0,1,1.462-.6,3.543,3.543,0,0,0,2.308-1.306A3.517,3.517,0,0,0,39,30.7a3.69,3.69,0,0,1-.205-1.592A3.608,3.608,0,0,1,39.734,27.884Zm-6.911-6.407-9.032,9.032a.631.631,0,0,1-.883,0l-4.622-4.622a.627.627,0,0,1,0-.883.619.619,0,0,1,.877,0l4.186,4.186,8.59-8.59a.627.627,0,0,1,.883,0A.62.62,0,0,1,32.823,21.477Z"
        transform="translate(-10 -10)"
        fill="#ffa333"
      />
    </svg>
  );
};

export const StarIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30.286"
      height="34.388"
      viewBox="0 0 30.286 34.388">
      <g id="Group_6718" data-name="Group 6718" transform="translate(0 0)">
        <path
          id="Path_17648"
          data-name="Path 17648"
          d="M34.9,995.362a10.146,10.146,0,1,0,9.9,10.143A10.022,10.022,0,0,0,34.9,995.362Zm0,3.246,1.955,4.146,4.38.659-3.167,3.22.742,4.552-3.909-2.143-3.909,2.143.742-4.552-3.167-3.22,4.38-.659,1.955-4.147Z"
          transform="translate(-19.721 -981.259)"
          fill="#ff6d5c"
        />
        <path
          id="Path_17648_-_Outline"
          data-name="Path 17648 - Outline"
          d="M10.379,963.112l6.964,11.464a11.381,11.381,0,0,1,4.61-2.019L14.267,959.7l-4.606,2.263m24.12-1.785-7.461,12.383a11.381,11.381,0,0,1,4.61,2.019L38.48,962.3l-4.448-2.527M8.961,962.3l5.979-2.938,8.335,13.832a10.684,10.684,0,0,0-6.148,2.586Zm24.373-2.938,5.913,3.369-8.1,13.05A10.684,10.684,0,0,0,25,973.194Z"
          transform="translate(-8.961 -959.362)"
          fill="#ff6d5c"
        />
      </g>
    </svg>
  );
};

export const AwardIcon = () => {
  return (
    <svg
      id="Award_leaderboard_rank_ranking"
      data-name="Award, leaderboard, rank, ranking"
      xmlns="http://www.w3.org/2000/svg"
      width="27.833"
      height="26.724"
      viewBox="0 0 27.833 26.724">
      <rect
        id="Rectangle_3794"
        data-name="Rectangle 3794"
        width="8.747"
        height="11.531"
        rx="1"
        transform="translate(9.543 15.192)"
        fill="#f28eb9"
      />
      <rect
        id="Rectangle_3795"
        data-name="Rectangle 3795"
        width="8.747"
        height="8.747"
        rx="1"
        transform="translate(0 17.976)"
        fill="#f28eb9"
      />
      <rect
        id="Rectangle_3796"
        data-name="Rectangle 3796"
        width="8.747"
        height="6.151"
        rx="1"
        transform="translate(19.085 20.573)"
        fill="#f28eb9"
      />
      <path
        id="Path_17587"
        data-name="Path 17587"
        d="M44.123,11.234a.805.805,0,0,0-.647-.553l-2.726-.4L39.544,7.813a.8.8,0,0,0-.734-.453h0a.808.808,0,0,0-.724.449L36.87,10.267l-2.72.388a.812.812,0,0,0-.647.55.8.8,0,0,0,.2.828l1.963,1.94-.472,2.707a.808.808,0,0,0,1.171.854l2.445-1.287,2.429,1.293a.789.789,0,0,0,.378.094.805.805,0,0,0,.8-.941l-.456-2.71,1.973-1.911A.812.812,0,0,0,44.123,11.234Z"
        transform="translate(-24.779 -7.36)"
        fill="#f28eb9"
      />
    </svg>
  );
};
export const MemoryIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="115.092"
      height="128.452"
      viewBox="0 0 115.092 128.452">
      <g id="Group_6770" data-name="Group 6770" opacity="0.1">
        <path
          id="Path_17668"
          data-name="Path 17668"
          d="M53.712,91h1.356a2.712,2.712,0,1,1,0,5.425H53.712a2.712,2.712,0,1,1,0-5.425Z"
          transform="translate(-1.577 32.026)"
          fill="#3f8669"
        />
        <path
          id="Path_17669"
          data-name="Path 17669"
          d="M20.42,17.269c6.668-6.446,17.1-8.637,24-10.085.921-.193,1.772-.371,2.536-.545,19.328-4.381,45.174-.345,57.192,15.852,4.958,6.68,6.79,15.008,7.928,22.273a44.541,44.541,0,0,1-.669,14.2,4.114,4.114,0,0,0-.114,1.207,11.919,11.919,0,0,0,2.532,5.694c6.362,7.445,8.315,10.111,8.7,11.889a7.08,7.08,0,0,1-1.57,6c-.462.524-1.512,1.36-5.269,2.587a4.282,4.282,0,0,0-.415.251c.117.184.262.4.374.559A6.643,6.643,0,0,1,117.13,92.5a6.786,6.786,0,0,1-1.343,2.711,3.791,3.791,0,0,1,.628,1.466,5.442,5.442,0,0,1-2.49,5.931,1.875,1.875,0,0,0,.045,1.117,14.066,14.066,0,0,0,.5,1.336,14.968,14.968,0,0,1,.915,2.8c.74,3.8-1.067,9.257-4.94,11.318-4.275,2.27-9.317,1.678-13.766,1.154-.873-.1-1.722-.2-2.529-.274-4.431-.387-10.47.414-14.1,6.453a13.907,13.907,0,0,0-.807,1.556,8.8,8.8,0,0,1-7.95,5.366H68.3a2.858,2.858,0,0,1,0-5.708h2.985a3.323,3.323,0,0,0,3.031-2.064,19.6,19.6,0,0,1,1.142-2.2c3.974-6.6,10.767-9.818,19.141-9.089.856.076,1.755.181,2.68.29,3.7.437,7.889.928,10.718-.575,1.4-.745,2.372-3.538,2.072-5.076a9.954,9.954,0,0,0-.589-1.7,19.931,19.931,0,0,1-.7-1.9c-.888-3.025-.092-5.9,1.979-7.431a3.809,3.809,0,0,1-1.518-3.027,3.081,3.081,0,0,1,1.242-2.352,4.929,4.929,0,0,0,1.3-1.276,9.183,9.183,0,0,0-.533-.826,6.422,6.422,0,0,1-1.439-5.224,6.334,6.334,0,0,1,3.727-4.19,2.824,2.824,0,0,1,.353-.143,19.21,19.21,0,0,0,3.2-1.256,1.275,1.275,0,0,0,.148-.569c-.763-1.605-5.61-7.278-7.544-9.54a17.381,17.381,0,0,1-3.822-9,10.111,10.111,0,0,1,.245-2.923,38.819,38.819,0,0,0,.6-11.967c-1.077-6.884-2.653-14.035-6.85-19.689C89.336,11.812,65.334,8.31,48.1,12.218c-.789.178-1.668.364-2.62.564-6.307,1.326-15.841,3.326-21.389,8.691-13.1,12.668-13.332,36.707-6.893,52.891A99.619,99.619,0,0,0,24.77,88.6c6.453,10.694,13.125,21.751,9.707,36.668a2.073,2.073,0,0,0,.353,1.715,1.826,1.826,0,0,0,1.471.749H52.422a2.858,2.858,0,0,1,0,5.708H36.3a7.127,7.127,0,0,1-5.731-2.927,7.987,7.987,0,0,1-1.364-6.584c2.878-12.564-2.9-22.136-9.013-32.27a103.885,103.885,0,0,1-8-15.09C4.862,58.138,5.333,31.852,20.42,17.269Z"
          transform="translate(-7.577 -4.989)"
          fill="#3f8669"
        />
        <path
          id="Path_17670"
          data-name="Path 17670"
          d="M65.087,52.118a38.026,38.026,0,0,1,.966,5.456,2.715,2.715,0,0,1-2.41,2.985c-.1.009-.2.015-.29.015a2.713,2.713,0,0,1-2.695-2.425,32.56,32.56,0,0,0-.822-4.672,2.712,2.712,0,1,1,5.251-1.359Z"
          transform="translate(-21.729 14.57)"
          fill="#3f8669"
        />
        <path
          id="Path_17671"
          data-name="Path 17671"
          d="M60.973,21.089a2.712,2.712,0,0,1-.707,3.77,2.806,2.806,0,0,0-1.3,2.051,2.243,2.243,0,0,0,.085.831,19.571,19.571,0,0,1,8.99,2.362c3.74-2.992,7.11-2.574,9.343-1.622a2.712,2.712,0,1,1-2.118,4.993,3.033,3.033,0,0,0-2.752.156,13.476,13.476,0,0,1,3.426,7.664,2.712,2.712,0,0,1-2.436,2.963,2.529,2.529,0,0,1-.266.014,2.71,2.71,0,0,1-2.7-2.449,8.367,8.367,0,0,0-2.677-5.206c-3.747-3.6-10.023-4.425-14.847-2.337.159.216.317.431.46.663,4.178-.144,8.549,1.412,9.932,6.256A2.712,2.712,0,1,1,58.2,42.687a3.371,3.371,0,0,0-3.188-2.274,9.071,9.071,0,0,1-2.262,6.019,2.712,2.712,0,0,1-4.058-3.6,4.043,4.043,0,0,0,.777-3.531,4.121,4.121,0,0,0-2.1-2.9c-.024-.011-.043-.026-.066-.037-.061-.028-.122-.058-.182-.092-.014-.008-.028-.009-.042-.018a10.767,10.767,0,0,0-5.36-1.446,11.248,11.248,0,0,0-4.546.928,2.713,2.713,0,0,1-2.2-4.962,16.169,16.169,0,0,1,3.373-1.066,2.038,2.038,0,0,0-.182-2.217A2.713,2.713,0,1,1,42.5,24.229a7.362,7.362,0,0,1,1.457,5.322,16.157,16.157,0,0,1,4.214,1.2,18.07,18.07,0,0,1,5.479-2.387,7.79,7.79,0,0,1-.081-1.919,8.238,8.238,0,0,1,3.64-6.062A2.713,2.713,0,0,1,60.973,21.089Z"
          transform="translate(1.097 1.689)"
          fill="#3f8669"
        />
        <path
          id="Path_17672"
          data-name="Path 17672"
          d="M62.692,30.058a2.711,2.711,0,0,1,2.6-2.824,2.759,2.759,0,0,1,2.824,2.6c.094,2.209.953,3.285,1.949,3.795.038-.056.064-.117.1-.172a2.713,2.713,0,1,1,4.45,3.1A8.924,8.924,0,0,0,72.99,41.41c-.075,2.727.979,3.894,3.366,6.274a31.7,31.7,0,0,1,4.09,4.717,2.712,2.712,0,1,1-4.478,3.059,26.32,26.32,0,0,0-3.352-3.845,3.506,3.506,0,0,0-3.554.473,2.712,2.712,0,1,1-3.5-4.144,8.519,8.519,0,0,1,2.958-1.607,11.323,11.323,0,0,1-.951-5.077,14.153,14.153,0,0,1,.359-2.654C65.253,37.363,62.887,34.7,62.692,30.058Z"
          transform="translate(-40.569 5.011)"
          fill="#3f8669"
        />
        <path
          id="Path_17673"
          data-name="Path 17673"
          d="M45.212,82.861c-.126.005-.252.008-.376.008a8.568,8.568,0,0,1-8.108-5.583c-3.134-8.521-5.2-9.264-5.431-9.319-.03-.008-.061-.016-.091-.026a14.955,14.955,0,0,1-6.351-2.868A2.713,2.713,0,1,1,28.2,60.8a9.541,9.541,0,0,0,4.169,1.84,3.47,3.47,0,0,1,.387.1c4.344,1.2,7.125,7.394,9.067,12.677a3.15,3.15,0,0,0,3.161,2.025l.576-.026c1.617-.068,3.032-2.057,3.291-3.8.142-.962.217-3.032.3-5.227.1-2.691.206-5.741.48-8.34a4.333,4.333,0,0,1,4.521-3.967,4.793,4.793,0,0,1,1.631.369,6.9,6.9,0,0,0,4.828.319,3.077,3.077,0,0,0,2.04-1.871c.075-.156.141-.289.2-.393a4.178,4.178,0,0,1,5.167-1.88,13.017,13.017,0,0,0,6.938.764,6.607,6.607,0,0,0,5.332-4.237c.9-2.35,3.312-2.908,4.756-3.241l.212-.049c2.533-.612,5.539-2.236,5.459-6.491a3.969,3.969,0,0,0-2.045-3.6c-2.407-1.492-3.729-4.534-4.131-6.683-.838-4.481-6.2-5.453-9.21-5.334-.275.012-.549.034-.826.069A8.073,8.073,0,0,1,67.982,21.8a9.263,9.263,0,0,0-3.648-2.049,2.712,2.712,0,0,1,1.543-5.2,14.727,14.727,0,0,1,5.781,3.26,2.708,2.708,0,0,0,2.166.628c.424-.053.846-.088,1.272-.106,6.392-.285,13.438,2.643,14.769,9.758a5.193,5.193,0,0,0,1.661,3.069,9.373,9.373,0,0,1,4.607,8.1c.108,5.951-3.481,10.388-9.627,11.874l-.251.058c-.309.072-.778.18-1.066.281a11.984,11.984,0,0,1-9.383,7.265,18.063,18.063,0,0,1-8.686-.7,8.322,8.322,0,0,1-4.851,3.883A11.8,11.8,0,0,1,54.9,61.89c-.172,2.133-.258,4.532-.335,6.693-.091,2.551-.164,4.566-.351,5.827-.586,3.936-3.74,8.225-8.426,8.422Z"
          transform="translate(-3.064 -1.623)"
          fill="#3f8669"
        />
        <path
          id="Path_17674"
          data-name="Path 17674"
          d="M52.867,33.2a12.8,12.8,0,0,1,3.956-9.741,15.137,15.137,0,0,1,10.019-4.254A17,17,0,0,1,69,19.259a2.372,2.372,0,0,0,1.96-.764,15.045,15.045,0,0,1,10.357-4.587,15.426,15.426,0,0,1,7.173,1.416,3.608,3.608,0,0,0,2.841-.016,14.86,14.86,0,0,1,1.408-.509,2.712,2.712,0,0,1,1.589,5.186,9.344,9.344,0,0,0-.9.327,8.983,8.983,0,0,1-7.231-.076,10.146,10.146,0,0,0-4.648-.91,9.776,9.776,0,0,0-6.647,2.9,7.865,7.865,0,0,1-6.382,2.436,11.658,11.658,0,0,0-1.444-.035,9.729,9.729,0,0,0-6.446,2.7,7.442,7.442,0,0,0-2.338,5.643,7.285,7.285,0,0,0,.18,1.33,6.846,6.846,0,0,1-1.219,5.872,7.239,7.239,0,0,0-1.583,4.783,7.412,7.412,0,0,0,3.011,5.586,6.328,6.328,0,0,1,2.468,4.877,7.073,7.073,0,0,0,.183,1.32,2.713,2.713,0,0,1-2.013,3.266,2.785,2.785,0,0,1-.629.073,2.713,2.713,0,0,1-2.636-2.086,12.374,12.374,0,0,1-.323-2.342c0-.014-.005-.142-.005-.155a.843.843,0,0,0-.363-.662,12.919,12.919,0,0,1-5.111-9.648,12.606,12.606,0,0,1,2.723-8.346,1.47,1.47,0,0,0,.224-1.272A12.494,12.494,0,0,1,52.867,33.2Z"
          transform="translate(-39.005 -1.817)"
          fill="#3f8669"
        />
      </g>
    </svg>
  );
};
export const GameIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="149.545"
      height="102.056"
      viewBox="0 0 149.545 102.056">
      <path
        id="Path_17678"
        data-name="Path 17678"
        d="M131.023,27.177a28.058,28.058,0,0,0-16.986-7.983c-5.152-.667-11,1.136-18.966,5.848-9.5,5.619-16.49,5.379-16.783,5.369-.237.008-7.227.255-16.731-5.369-6.9-4.083-12.213-5.983-16.863-5.983a16.348,16.348,0,0,0-2.1.134,28.058,28.058,0,0,0-16.987,7.983c-8.825,8.4-22.065,24.872-21,70.7.263,11.382,3.853,18.722,10.11,20.668,7.947,2.473,19.025-3.826,27.584-15.661,5.94-8.229,12.358-10.968,29.007-10.968H85.326c16.647,0,21.437,2.739,27.376,10.968,8.559,11.836,21.265,18.126,29.213,15.661,6.257-1.946,9.849-9.286,10.111-20.668C153.088,52.051,139.848,35.579,131.023,27.177ZM60.412,60.421a2.325,2.325,0,0,1-2.321,2.321H49.619A1.158,1.158,0,0,0,48.463,63.9v8.471a2.325,2.325,0,0,1-2.321,2.321H38.905a2.325,2.325,0,0,1-2.323-2.321V63.9a1.158,1.158,0,0,0-1.157-1.157H26.943a2.325,2.325,0,0,1-2.321-2.321V53.185a2.325,2.325,0,0,1,2.321-2.323h8.483a1.158,1.158,0,0,0,1.157-1.157V41.223A2.325,2.325,0,0,1,38.905,38.9h7.236a2.325,2.325,0,0,1,2.321,2.321v8.483a1.158,1.158,0,0,0,1.157,1.157h8.471a2.325,2.325,0,0,1,2.321,2.323v7.236Zm45.43-17.3a6.188,6.188,0,0,1,6.182-6.181h1.339a6.188,6.188,0,0,1,6.182,6.181v1.339a6.189,6.189,0,0,1-6.182,6.182h-1.339a6.189,6.189,0,0,1-6.182-6.182V43.118Zm-4.8,19.84H99.706a6.189,6.189,0,0,1-6.182-6.182V55.437a6.189,6.189,0,0,1,6.182-6.182h1.339a6.189,6.189,0,0,1,6.182,6.182v1.339A6.188,6.188,0,0,1,101.045,62.958Zm18.5,6.274a6.189,6.189,0,0,1-6.182,6.182h-1.339a6.189,6.189,0,0,1-6.182-6.182V67.893a6.189,6.189,0,0,1,6.182-6.182h1.339a6.189,6.189,0,0,1,6.182,6.182ZM132,56.776a6.188,6.188,0,0,1-6.181,6.182h-1.339a6.189,6.189,0,0,1-6.182-6.182V55.437a6.189,6.189,0,0,1,6.182-6.182h1.339A6.188,6.188,0,0,1,132,55.437Z"
        transform="translate(-3.542 -18.06)"
        fill="none"
        stroke="#8863eb"
        stroke-width="2"
        opacity="0.39"
      />
    </svg>
  );
};
export const GroupsIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24.923"
      height="28.778"
      viewBox="0 0 24.923 28.778">
      <g id="Group_6807" data-name="Group 6807" transform="translate(-11.211 -5.21)">
        <path
          id="Path_17680"
          data-name="Path 17680"
          d="M38.105,17.753l-10.69-6.172-10.69,6.172V30.094l10.69,6.172,10.69-6.172V17.753ZM27.416,14.43A2.107,2.107,0,0,1,29.3,17.478,2.015,2.015,0,0,1,30.725,18.7a2.587,2.587,0,0,1,3.721,3.42,2.462,2.462,0,0,1,2.082,2.426V28.6a.434.434,0,0,1-.238.387,8.509,8.509,0,0,1-4.182,1.1v1.742a.434.434,0,0,1-.239.388,8.86,8.86,0,0,1-8.907,0,.434.434,0,0,1-.239-.388V30.087a8.489,8.489,0,0,1-4.182-1.1A.435.435,0,0,1,18.3,28.6V24.544a2.462,2.462,0,0,1,2.082-2.426,2.587,2.587,0,0,1,3.721-3.42,2.016,2.016,0,0,1,1.425-1.219,2.107,2.107,0,0,1,1.884-3.048Z"
          transform="translate(-3.743 -4.324)"
          fill="#ff7464"
          fill-rule="evenodd"
        />
        <circle
          id="Ellipse_1020"
          data-name="Ellipse 1020"
          cx="1.718"
          cy="1.718"
          r="1.718"
          transform="translate(16.631 15.56) rotate(-22.5)"
          fill="#ff7464"
        />
        <circle
          id="Ellipse_1021"
          data-name="Ellipse 1021"
          cx="1.926"
          cy="1.926"
          r="1.926"
          transform="translate(21.746 17.037)"
          fill="#ff7464"
        />
        <path
          id="Path_17681"
          data-name="Path 17681"
          d="M30.2,48.781A2.8,2.8,0,0,1,29.805,47c-.183-.017-.388-.007-.573-.007a2.588,2.588,0,0,1-2.894,0h-.415a1.592,1.592,0,0,0-1.586,1.586v3.8a8.7,8.7,0,0,0,1.219.512v-2.73a.434.434,0,0,1,.868,0v2.961a6.852,6.852,0,0,0,1.464.137V51.409a2.658,2.658,0,0,1,2.31-2.628Z"
          transform="translate(-8.91 -28.355)"
          fill="#ff7464"
          fill-rule="evenodd"
        />
        <path
          id="Path_17682"
          data-name="Path 17682"
          d="M57.808,47a2.809,2.809,0,0,1,.018.322,2.779,2.779,0,0,1-.413,1.463,2.658,2.658,0,0,1,2.31,2.628v1.841a6.854,6.854,0,0,0,1.465-.137V50.153a.434.434,0,0,1,.868,0v2.73a8.737,8.737,0,0,0,1.219-.512v-3.8A1.592,1.592,0,0,0,61.69,46.99h-.415a2.588,2.588,0,0,1-2.894,0c-.185,0-.39-.01-.573.007Z"
          transform="translate(-31.359 -28.356)"
          fill="#ff7464"
          fill-rule="evenodd"
        />
        <path
          id="Path_17683"
          data-name="Path 17683"
          d="M43.456,58.721a.434.434,0,0,1,.868,0v3.051a9.58,9.58,0,0,0,1.421-.593V56.991a1.787,1.787,0,0,0-1.781-1.781H43.5a2.8,2.8,0,0,1-3.148,0H39.88A1.787,1.787,0,0,0,38.1,56.991v4.188a9.546,9.546,0,0,0,1.421.593V58.721a.434.434,0,0,1,.868,0V62a7.49,7.49,0,0,0,3.067,0V58.721Z"
          transform="translate(-18.25 -33.937)"
          fill="#ff7464"
          fill-rule="evenodd"
        />
        <circle
          id="Ellipse_1022"
          data-name="Ellipse 1022"
          cx="1.237"
          cy="1.237"
          r="1.237"
          transform="translate(22.435 10.974)"
          fill="#ff7464"
        />
        <path
          id="Path_17684"
          data-name="Path 17684"
          d="M45.7,32.489a2.107,2.107,0,0,1-2.307,0H43.1a1.137,1.137,0,0,0-1.135,1.18,2.589,2.589,0,0,1,.019,2.64l.022,0a2.8,2.8,0,0,1,5.082,0l.022,0a2.589,2.589,0,0,1,.019-2.64,1.137,1.137,0,0,0-1.135-1.18H45.7Z"
          transform="translate(-20.875 -18.515)"
          fill="#ff7464"
          fill-rule="evenodd"
        />
        <path
          id="Path_17685"
          data-name="Path 17685"
          d="M36.134,12.405,23.673,5.21,11.213,12.4q0,7.2,0,14.39l12.461,7.2L36.132,26.8q0-7.2,0-14.39h0ZM23.889,6.382,35.011,12.8a.432.432,0,0,1,.216.374V26a.433.433,0,0,1-.216.4L23.894,32.814a.433.433,0,0,1-.439,0L12.334,26.394a.432.432,0,0,1-.216-.374V13.2a.433.433,0,0,1,.216-.4L23.451,6.385a.433.433,0,0,1,.439,0Z"
          fill="#ff7464"
          fill-rule="evenodd"
        />
        <circle
          id="Ellipse_1023"
          data-name="Ellipse 1023"
          cx="1.718"
          cy="1.718"
          r="1.718"
          transform="translate(26.039 16.49) rotate(-45)"
          fill="#ff7464"
        />
      </g>
    </svg>
  );
};

export const HexagonIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="100.762" height="92" viewBox="0 0 100.762 92">
      <path
        id="Polygon_71"
        data-name="Polygon 71"
        d="M36.326,2a15,15,0,0,0-13,7.512l-16.707,29a15,15,0,0,0,0,14.975l16.707,29a15,15,0,0,0,13,7.512H69.674a15,15,0,0,0,13-7.512l16.707-29a15,15,0,0,0,0-14.975l-16.707-29A15,15,0,0,0,69.674,2H36.326m0-2H69.674A17,17,0,0,1,84.4,8.514l16.707,29a17,17,0,0,1,0,16.972l-16.707,29A17,17,0,0,1,69.674,92H36.326A17,17,0,0,1,21.6,83.486l-16.707-29a17,17,0,0,1,0-16.972l16.707-29A17,17,0,0,1,36.326,0Z"
        transform="translate(-2.619)"
        fill="#d7d7df"
      />
    </svg>
  );
};

export const MoodIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="359.201"
      height="400.899"
      viewBox="0 0 359.201 400.899">
      <g id="Group_6770" data-name="Group 6770" opacity="0.1">
        <path
          id="Path_17668"
          data-name="Path 17668"
          d="M63.7,91H59.465a8.465,8.465,0,0,0,0,16.93H63.7A8.465,8.465,0,0,0,63.7,91Z"
          transform="translate(132.79 292.964)"
          fill="#3f8669"
        />
        <path
          id="Path_17669"
          data-name="Path 17669"
          d="M326.695,43.314c-20.811-20.118-53.36-26.955-74.9-31.475-2.874-.6-5.532-1.158-7.915-1.7C183.558-3.536,102.894,9.059,65.385,59.61c-15.474,20.848-21.192,46.841-24.744,69.516-2.091,13.388-.487,32.829,2.087,44.325a12.839,12.839,0,0,1,.355,3.768c-.212,3.127-2.743,11.736-7.9,17.771-19.855,23.236-25.95,31.556-27.156,37.1a22.1,22.1,0,0,0,4.9,18.715c1.443,1.635,4.719,4.245,16.444,8.075a13.361,13.361,0,0,1,1.3.784c-.364.575-.817,1.234-1.168,1.746-2.358,3.421-6.3,9.135-4.635,16.711a21.179,21.179,0,0,0,4.19,8.462,11.831,11.831,0,0,0-1.96,4.574c-1.71,9.05,2.874,16,7.771,18.51a5.853,5.853,0,0,1-.14,3.487,43.9,43.9,0,0,1-1.553,4.169,46.715,46.715,0,0,0-2.857,8.747C28,337.945,33.645,354.967,45.734,361.4c13.341,7.086,29.078,5.238,42.965,3.6,2.726-.321,5.375-.637,7.894-.855,13.828-1.207,32.675,1.292,44.019,20.14a43.405,43.405,0,0,1,2.518,4.855c4.5,10.172,14.234,16.746,24.811,16.746h9.316a8.919,8.919,0,0,0,0-17.815H167.94a10.372,10.372,0,0,1-9.46-6.44,61.167,61.167,0,0,0-3.564-6.872c-12.4-20.59-33.6-30.642-59.738-28.367-2.671.236-5.477.566-8.363.9-11.542,1.363-24.621,2.9-33.45-1.795-4.376-2.325-7.4-11.041-6.467-15.842a31.065,31.065,0,0,1,1.837-5.3,62.209,62.209,0,0,0,2.171-5.928c2.772-9.442.288-18.417-6.175-23.191,2.243-2.071,4.922-4.895,4.736-9.447a9.615,9.615,0,0,0-3.877-7.34,15.382,15.382,0,0,1-4.051-3.982A28.663,28.663,0,0,1,43.2,271.89c2.311-3.354,6.184-8.97,4.491-16.305-1.274-5.505-5.185-9.91-11.631-13.077a8.814,8.814,0,0,0-1.1-.445,59.957,59.957,0,0,1-9.993-3.919,3.98,3.98,0,0,1-.461-1.777c2.383-5.011,17.51-22.715,23.546-29.774,7.983-9.344,11.508-21.922,11.927-28.095a31.557,31.557,0,0,0-.766-9.121c-2.18-9.745-3.513-26.794-1.858-37.35,3.361-21.485,8.279-43.8,21.379-61.45,32.874-44.294,107.782-55.223,161.582-43.024,2.463.557,5.206,1.136,8.177,1.759,19.686,4.138,49.441,10.382,66.756,27.124,40.9,39.537,41.61,114.562,21.514,165.073-6.125,15.388-15.034,30.153-23.647,44.427-20.138,33.377-40.963,67.885-30.3,114.442a6.47,6.47,0,0,1-1.1,5.354,5.7,5.7,0,0,1-4.592,2.338H226.815a8.919,8.919,0,0,0,0,17.815h50.312a22.242,22.242,0,0,0,17.887-9.135,24.927,24.927,0,0,0,4.258-20.55c-8.982-39.212,9.049-69.088,28.13-100.715,8.994-14.9,18.289-30.313,24.968-47.1C375.251,170.867,373.782,88.828,326.695,43.314Z"
          transform="translate(-7.577 -4.989)"
          fill="#3f8669"
        />
        <path
          id="Path_17670"
          data-name="Path 17670"
          d="M62.81,56.43A118.68,118.68,0,0,0,59.8,73.457a8.472,8.472,0,0,0,7.521,9.316c.3.03.609.047.906.047a8.467,8.467,0,0,0,8.41-7.568A101.623,101.623,0,0,1,79.2,60.671,8.464,8.464,0,1,0,62.81,56.43Z"
          transform="translate(161.071 151.703)"
          fill="#3f8669"
        />
        <path
          id="Path_17671"
          data-name="Path 17671"
          d="M89.736,23.588a8.464,8.464,0,0,0,2.205,11.767A8.757,8.757,0,0,1,96,41.755a7,7,0,0,1-.267,2.595,61.082,61.082,0,0,0-28.058,7.373C56,42.385,45.48,43.689,38.513,46.66a8.464,8.464,0,1,0,6.611,15.584,9.466,9.466,0,0,1,8.588.487A42.058,42.058,0,0,0,43.021,86.649a8.464,8.464,0,0,0,7.6,9.248,7.9,7.9,0,0,0,.83.042A8.458,8.458,0,0,0,59.866,88.3a26.112,26.112,0,0,1,8.355-16.249C79.916,60.8,99.5,58.236,114.559,64.754c-.5.673-.99,1.346-1.435,2.07-13.041-.449-26.682,4.406-31,19.525A8.464,8.464,0,1,0,98.4,91c1.388-4.859,5.689-6.6,9.951-7.1a28.309,28.309,0,0,0,7.06,18.784,8.464,8.464,0,0,0,12.664-11.233c-3.513-3.962-2.865-9.028-2.425-11.022.923-4.161,3.5-7.712,6.569-9.049.076-.034.135-.08.207-.114.19-.089.381-.182.567-.288.042-.025.089-.03.131-.055a33.6,33.6,0,0,1,16.727-4.512,35.1,35.1,0,0,1,14.188,2.9,8.468,8.468,0,0,0,6.853-15.487,50.463,50.463,0,0,0-10.526-3.327,6.361,6.361,0,0,1,.567-6.92A8.466,8.466,0,1,0,147.4,33.391,22.979,22.979,0,0,0,142.858,50a50.428,50.428,0,0,0-13.151,3.75,56.4,56.4,0,0,0-17.1-7.449,24.314,24.314,0,0,0,.254-5.989,25.71,25.71,0,0,0-11.36-18.92A8.466,8.466,0,0,0,89.736,23.588Z"
          transform="translate(75.745 47.502)"
          fill="#3f8669"
        />
        <path
          id="Path_17672"
          data-name="Path 17672"
          d="M119.578,36.048a8.461,8.461,0,0,0-8.1-8.812,8.611,8.611,0,0,0-8.812,8.1c-.292,6.895-2.976,10.251-6.082,11.843-.119-.174-.2-.364-.322-.538A8.466,8.466,0,1,0,82.374,56.33a27.851,27.851,0,0,1,5.062,15.148c.233,8.512-3.056,12.152-10.505,19.58a98.918,98.918,0,0,0-12.765,14.721,8.463,8.463,0,1,0,13.976,9.549,82.147,82.147,0,0,1,10.463-12A10.942,10.942,0,0,1,99.7,104.806a8.464,8.464,0,0,0,10.92-12.935,26.587,26.587,0,0,0-9.231-5.016,35.339,35.339,0,0,0,2.967-15.847,44.172,44.172,0,0,0-1.122-8.283C111.583,58.849,118.969,50.527,119.578,36.048Z"
          transform="translate(170.576 73.402)"
          fill="#3f8669"
        />
        <path
          id="Path_17673"
          data-name="Path 17673"
          d="M182.746,227.98c.394.017.787.025,1.172.025a26.741,26.741,0,0,0,25.306-17.425c9.781-26.593,16.245-28.913,16.951-29.086.093-.025.19-.051.284-.08a46.674,46.674,0,0,0,19.821-8.952,8.466,8.466,0,1,0-10.433-13.337,29.779,29.779,0,0,1-13.011,5.744,10.828,10.828,0,0,0-1.206.309c-13.557,3.759-22.238,23.076-28.3,39.566a9.83,9.83,0,0,1-9.866,6.319l-1.8-.08c-5.045-.212-9.464-6.421-10.272-11.855-.444-3-.677-9.464-.923-16.312-.3-8.4-.643-17.916-1.5-26.03-.779-7.4-6.315-12.257-14.111-12.38a14.96,14.96,0,0,0-5.092,1.151c-3.141,1.172-8.393,3.149-15.068.995a9.6,9.6,0,0,1-6.366-5.841c-.233-.487-.44-.9-.618-1.227a13.04,13.04,0,0,0-16.126-5.866c-6.819,2.421-13.108,3.754-21.654,2.383A20.621,20.621,0,0,1,73.3,122.776c-2.8-7.335-10.336-9.075-14.844-10.116l-.66-.152c-7.906-1.909-17.286-6.979-17.036-20.257a12.387,12.387,0,0,1,6.383-11.233c7.513-4.656,11.64-14.149,12.892-20.858C62.647,46.175,79.387,43.14,88.774,43.513c.859.038,1.714.106,2.578.216a25.2,25.2,0,0,0,20.329-6.311,28.909,28.909,0,0,1,11.386-6.4,8.464,8.464,0,0,0-4.817-16.228A45.964,45.964,0,0,0,100.207,24.97a8.452,8.452,0,0,1-6.759,1.96c-1.325-.165-2.641-.275-3.97-.33-19.948-.889-41.94,8.249-46.093,30.453-.741,3.97-3.06,8.262-5.185,9.578A29.254,29.254,0,0,0,23.822,91.92c-.339,18.573,10.865,32.421,30.047,37.06l.783.182c.965.224,2.429.563,3.327.876,5.2,12.283,15.8,20.519,29.285,22.674a56.375,56.375,0,0,0,27.109-2.171,25.972,25.972,0,0,0,15.14,12.118,36.816,36.816,0,0,0,22.987-.131c.538,6.658.8,14.145,1.045,20.888.284,7.961.512,14.251,1.1,18.187,1.828,12.283,11.673,25.67,26.3,26.284Z"
          transform="translate(44.911 25.566)"
          fill="#3f8669"
        />
        <path
          id="Path_17674"
          data-name="Path 17674"
          d="M185.62,74.153a39.958,39.958,0,0,0-12.346-30.4A47.243,47.243,0,0,0,142,30.473a53.047,53.047,0,0,0-6.734.161,7.4,7.4,0,0,1-6.116-2.383A46.955,46.955,0,0,0,96.829,13.937a48.144,48.144,0,0,0-22.386,4.419,11.261,11.261,0,0,1-8.867-.051,46.38,46.38,0,0,0-4.393-1.587A8.464,8.464,0,0,0,56.222,32.9a29.162,29.162,0,0,1,2.823,1.02,28.037,28.037,0,0,0,22.568-.237,31.664,31.664,0,0,1,14.5-2.84,30.512,30.512,0,0,1,20.744,9.045,24.546,24.546,0,0,0,19.918,7.6,36.386,36.386,0,0,1,4.508-.11,30.363,30.363,0,0,1,20.117,8.44,23.228,23.228,0,0,1,7.3,17.612,22.734,22.734,0,0,1-.563,4.152,21.367,21.367,0,0,0,3.805,18.327,22.594,22.594,0,0,1,4.939,14.928,23.134,23.134,0,0,1-9.4,17.434,19.75,19.75,0,0,0-7.7,15.22,22.078,22.078,0,0,1-.571,4.118,8.468,8.468,0,0,0,6.281,10.192,8.694,8.694,0,0,0,1.964.229,8.468,8.468,0,0,0,8.228-6.51,38.62,38.62,0,0,0,1.007-7.31c0-.042.017-.444.017-.483a2.632,2.632,0,0,1,1.134-2.066,40.32,40.32,0,0,0,15.952-30.11,39.344,39.344,0,0,0-8.5-26.047,4.588,4.588,0,0,1-.7-3.97A38.99,38.99,0,0,0,185.62,74.153Z"
          transform="translate(130.32 23.804)"
          fill="#3f8669"
        />
      </g>
    </svg>
  );
};

export const NoviceIcon = ({ width, height }) => {
  return (
    <svg
      id="Group_7080"
      data-name="Group 7080"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}>
      <defs>
        <filter
          id="Path_18948"
          x="4.283"
          y="0"
          width="24.512"
          height="28.182"
          filterUnits="userSpaceOnUse">
          <feOffset dy="3" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="3" result="blur" />
          <feFlood flood-opacity="0.161" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="Path_18953"
          x="1.625"
          y="11.586"
          width="36.039"
          height="34.683"
          filterUnits="userSpaceOnUse">
          <feOffset dy="3" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="3" result="blur-2" />
          <feFlood flood-opacity="0.161" />
          <feComposite operator="in" in2="blur-2" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="Path_18954"
          x="9.054"
          y="0"
          width="21.18"
          height="28.182"
          filterUnits="userSpaceOnUse">
          <feOffset dy="3" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="3" result="blur-3" />
          <feFlood flood-opacity="0.161" />
          <feComposite operator="in" in2="blur-3" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="Path_18955"
          x="13.506"
          y="0"
          width="21.498"
          height="27.024"
          filterUnits="userSpaceOnUse">
          <feOffset dy="3" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="3" result="blur-4" />
          <feFlood flood-opacity="0.161" />
          <feComposite operator="in" in2="blur-4" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="Path_18956"
          x="9.69"
          y="10.177"
          width="19.908"
          height="19.908"
          filterUnits="userSpaceOnUse">
          <feOffset dy="3" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="3" result="blur-5" />
          <feFlood flood-opacity="0.161" />
          <feComposite operator="in" in2="blur-5" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g id="Group_7152" data-name="Group 7152" transform="translate(-104.295 -183.939)">
        <g id="Group_7151" data-name="Group 7151" transform="translate(104.295 186.29)">
          <g id="Polygon_70" data-name="Polygon 70" transform="translate(0 0)" fill="#fbbb4a">
            <path
              d="M 27.05220794677734 33.64999771118164 L 12.87061882019043 33.64999771118164 C 11.4445686340332 33.64999771118164 10.11647891998291 32.88237762451172 9.404618263244629 31.64670753479004 L 2.304348707199097 19.32170677185059 C 1.594838619232178 18.090087890625 1.594838619232178 16.55989646911621 2.304348707199097 15.32827663421631 L 9.404628753662109 3.003286838531494 C 10.11647891998291 1.767606973648071 11.4445686340332 0.9999969601631165 12.87061882019043 0.9999969601631165 L 27.05220794677734 0.9999969601631165 C 28.47825813293457 0.9999969601631165 29.80634880065918 1.767606973648071 30.51819801330566 3.003286838531494 L 37.61846923828125 15.32828712463379 C 38.32799911499023 16.55990600585938 38.32799911499023 18.090087890625 37.61846923828125 19.32170677185059 L 30.51819801330566 31.64670753479004 C 29.80634880065918 32.88238525390625 28.47825813293457 33.64999771118164 27.05220794677734 33.64999771118164 Z"
              stroke="none"
            />
            <path
              d="M 12.87061882019043 1.999996185302734 C 11.80107879638672 1.999996185302734 10.80500793457031 2.575706481933594 10.2711181640625 3.502466201782227 L 3.170848846435547 15.82745742797852 C 2.638710021972656 16.75116729736328 2.638710021972656 17.89881706237793 3.170848846435547 18.8225269317627 L 10.2711181640625 31.14752769470215 C 10.80500793457031 32.07428741455078 11.80107879638672 32.64999771118164 12.87061882019043 32.64999771118164 L 27.05220794677734 32.64999771118164 C 28.12173843383789 32.64999771118164 29.1178092956543 32.07428741455078 29.65169906616211 31.14752769470215 L 36.75196838378906 18.8225269317627 C 37.28410720825195 17.89881706237793 37.28410720825195 16.75116729736328 36.75196838378906 15.82745742797852 L 29.65169906616211 3.502466201782227 C 29.1178092956543 2.575706481933594 28.12173843383789 1.999996185302734 27.05220794677734 1.999996185302734 L 12.87061882019043 1.999996185302734 M 12.87061882019043 -3.814697265625e-06 L 27.05220794677734 -3.814697265625e-06 C 28.84022903442383 -3.814697265625e-06 30.49215888977051 0.9547882080078125 31.38469886779785 2.504108428955078 L 38.48497009277344 14.82909774780273 C 39.37496948242188 16.3740177154541 39.37496948242188 18.27597618103027 38.48497009277344 19.82088661193848 L 31.38469886779785 32.1458854675293 C 30.49215888977051 33.69520568847656 28.84022903442383 34.64999771118164 27.05220794677734 34.64999771118164 L 12.87061882019043 34.64999771118164 C 11.08259773254395 34.64999771118164 9.430658340454102 33.69520568847656 8.538118362426758 32.1458854675293 L 1.437847137451172 19.82088661193848 C 0.5478401184082031 18.27596664428711 0.5478401184082031 16.3740177154541 1.437847137451172 14.82909774780273 L 8.538118362426758 2.504108428955078 C 9.430667877197266 0.9547882080078125 11.08259773254395 -3.814697265625e-06 12.87061882019043 -3.814697265625e-06 Z"
              stroke="none"
              fill="#ffe87a"
            />
          </g>
        </g>
        <g id="Group_7150" data-name="Group 7150" transform="translate(115.988 189.939)">
          <g id="Group_7069" data-name="Group 7069">
            <g transform="matrix(1, 0, 0, 1, -11.69, -6)" filter="url(#Path_18948)">
              <path
                id="Path_18948-2"
                data-name="Path 18948"
                d="M26.919,959.362v7.633l3.5,1.4v-9.034Zm6.341,10.177Zm0,0c-.517.011.547,0,.02,0h-.02Z"
                transform="translate(-13.64 -953.36)"
                fill="#17256b"
              />
            </g>
            <g transform="matrix(1, 0, 0, 1, -11.69, -6)" filter="url(#Path_18953)">
              <path
                id="Path_18953-2"
                data-name="Path 18953"
                d="M32.951,973.944Zm0,0L30.5,978.973l-5.5.805,3.976,3.906-.934,5.526,4.91-2.605,4.91,2.6-.934-5.524,3.976-3.906-5.5-.808-2.455-5.028Z"
                transform="translate(-13.31 -955.86)"
                fill="#f3f7ff"
                stroke="#fbbb4a"
                stroke-width="1"
              />
            </g>
          </g>
          <g transform="matrix(1, 0, 0, 1, -11.69, -6)" filter="url(#Path_18954)">
            <path
              id="Path_18954-2"
              data-name="Path 18954"
              d="M32.675,959.362v9.551l1.57.626,1.61-.646v-9.531Zm1.57,10.177c-.517.011.547,0,.02,0h-.02Z"
              transform="translate(-14.62 -953.36)"
              fill="#ca373c"
            />
          </g>
          <g transform="matrix(1, 0, 0, 1, -11.69, -6)" filter="url(#Path_18955)">
            <path
              id="Path_18955-2"
              data-name="Path 18955"
              d="M38.046,959.362v9.024l3.5-1.391v-7.633Z"
              transform="translate(-15.54 -953.36)"
              fill="#17256b"
            />
          </g>
          <g transform="matrix(1, 0, 0, 1, -11.69, -6)" filter="url(#Path_18956)">
            <path
              id="Path_18956-2"
              data-name="Path 18956"
              d="M34.376,971.641Zm0,0a.964.964,0,1,0,.02,0h-.02Zm.02,1.908h0Z"
              transform="translate(-14.75 -955.46)"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};
export const IntermediateIcon = ({ width, height }) => {
  return (
    <svg
      id="Group_7080"
      data-name="Group 7080"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}>
      <defs>
        <filter
          id="Path_18949"
          x="3.667"
          y="10.438"
          width="32.391"
          height="32.391"
          filterUnits="userSpaceOnUse">
          <feOffset dy="3" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="3" result="blur" />
          <feFlood flood-opacity="0.161" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="Path_18950"
          x="6.5"
          y="13.388"
          width="26.827"
          height="26.827"
          filterUnits="userSpaceOnUse">
          <feOffset dy="3" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="3" result="blur-2" />
          <feFlood flood-opacity="0.161" />
          <feComposite operator="in" in2="blur-2" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="Path_18951"
          x="3.816"
          y="0"
          width="24.491"
          height="26.648"
          filterUnits="userSpaceOnUse">
          <feOffset dy="3" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="3" result="blur-3" />
          <feFlood flood-opacity="0.161" />
          <feComposite operator="in" in2="blur-3" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="Path_18952"
          x="9.009"
          y="0"
          width="26.901"
          height="27.629"
          filterUnits="userSpaceOnUse">
          <feOffset dy="3" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="3" result="blur-4" />
          <feFlood flood-opacity="0.161" />
          <feComposite operator="in" in2="blur-4" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g id="Group_7153" data-name="Group 7153" transform="translate(-104.295 -185.362)">
        <g id="Group_7151" data-name="Group 7151" transform="translate(104.295 186.29)">
          <g id="Polygon_70" data-name="Polygon 70" transform="translate(0 0)" fill="#f8a642">
            <path
              d="M 27.05220794677734 33.64999771118164 L 12.87061882019043 33.64999771118164 C 11.4445686340332 33.64999771118164 10.11647891998291 32.88237762451172 9.404618263244629 31.64670753479004 L 2.304348707199097 19.32170677185059 C 1.594838619232178 18.090087890625 1.594838619232178 16.55989646911621 2.304348707199097 15.32827663421631 L 9.404628753662109 3.003286838531494 C 10.11647891998291 1.767606973648071 11.4445686340332 0.9999969601631165 12.87061882019043 0.9999969601631165 L 27.05220794677734 0.9999969601631165 C 28.47825813293457 0.9999969601631165 29.80634880065918 1.767606973648071 30.51819801330566 3.003286838531494 L 37.61846923828125 15.32828712463379 C 38.32799911499023 16.55990600585938 38.32799911499023 18.090087890625 37.61846923828125 19.32170677185059 L 30.51819801330566 31.64670753479004 C 29.80634880065918 32.88238525390625 28.47825813293457 33.64999771118164 27.05220794677734 33.64999771118164 Z"
              stroke="none"
            />
            <path
              d="M 12.87061882019043 1.999996185302734 C 11.80107879638672 1.999996185302734 10.80500793457031 2.575706481933594 10.2711181640625 3.502466201782227 L 3.170848846435547 15.82745742797852 C 2.638710021972656 16.75116729736328 2.638710021972656 17.89881706237793 3.170848846435547 18.8225269317627 L 10.2711181640625 31.14752769470215 C 10.80500793457031 32.07428741455078 11.80107879638672 32.64999771118164 12.87061882019043 32.64999771118164 L 27.05220794677734 32.64999771118164 C 28.12173843383789 32.64999771118164 29.1178092956543 32.07428741455078 29.65169906616211 31.14752769470215 L 36.75196838378906 18.8225269317627 C 37.28410720825195 17.89881706237793 37.28410720825195 16.75116729736328 36.75196838378906 15.82745742797852 L 29.65169906616211 3.502466201782227 C 29.1178092956543 2.575706481933594 28.12173843383789 1.999996185302734 27.05220794677734 1.999996185302734 L 12.87061882019043 1.999996185302734 M 12.87061882019043 -3.814697265625e-06 L 27.05220794677734 -3.814697265625e-06 C 28.84022903442383 -3.814697265625e-06 30.49215888977051 0.9547882080078125 31.38469886779785 2.504108428955078 L 38.48497009277344 14.82909774780273 C 39.37496948242188 16.3740177154541 39.37496948242188 18.27597618103027 38.48497009277344 19.82088661193848 L 31.38469886779785 32.1458854675293 C 30.49215888977051 33.69520568847656 28.84022903442383 34.64999771118164 27.05220794677734 34.64999771118164 L 12.87061882019043 34.64999771118164 C 11.08259773254395 34.64999771118164 9.430658340454102 33.69520568847656 8.538118362426758 32.1458854675293 L 1.437847137451172 19.82088661193848 C 0.5478401184082031 18.27596664428711 0.5478401184082031 16.3740177154541 1.437847137451172 14.82909774780273 L 8.538118362426758 2.504108428955078 C 9.430667877197266 0.9547882080078125 11.08259773254395 -3.814697265625e-06 12.87061882019043 -3.814697265625e-06 Z"
              stroke="none"
              fill="#ffe87a"
            />
          </g>
        </g>
        <g id="Group_7154" data-name="Group 7154" transform="translate(116.962 191.362)">
          <g transform="matrix(1, 0, 0, 1, -12.67, -6)" filter="url(#Path_18949)">
            <path
              id="Path_18949-2"
              data-name="Path 18949"
              d="M27.6,56.435a.8.8,0,0,1,.162.929l-.207.416A1.8,1.8,0,0,0,27.6,59.47a1.754,1.754,0,0,0,1.423.888l.459.027a.778.778,0,0,1,.714.606l.106.453a1.77,1.77,0,0,0,1.112,1.264,1.74,1.74,0,0,0,1.654-.245l.369-.278a.778.778,0,0,1,.932,0l.369.278a1.741,1.741,0,0,0,1.654.245,1.771,1.771,0,0,0,1.112-1.264l.106-.453a.778.778,0,0,1,.714-.606l.459-.027a1.754,1.754,0,0,0,1.423-.888,1.8,1.8,0,0,0,.049-1.691l-.207-.416a.8.8,0,0,1,.162-.928l.335-.32a1.792,1.792,0,0,0-.511-2.932L39.616,53a.8.8,0,0,1-.466-.817l.053-.462a1.788,1.788,0,0,0-.617-1.572,1.742,1.742,0,0,0-1.638-.342l-.441.134a.771.771,0,0,1-.876-.322l-.253-.389a1.75,1.75,0,0,0-2.943,0l-.253.389a.781.781,0,0,1-.876.322l-.441-.134a1.744,1.744,0,0,0-1.638.342,1.788,1.788,0,0,0-.617,1.572l.053.462A.8.8,0,0,1,28.2,53l-.423.184a1.792,1.792,0,0,0-.511,2.932Zm6.308-6.052a5.406,5.406,0,1,1-5.344,5.406,5.406,5.406,0,0,1,5.344-5.406Z"
              transform="translate(-14.05 -31.99)"
              fill="#ffe87a"
            />
          </g>
          <g transform="matrix(1, 0, 0, 1, -12.67, -6)" filter="url(#Path_18950)">
            <path
              id="Path_18950-2"
              data-name="Path 18950"
              d="M40.243,66.8a4.413,4.413,0,1,0-4.362-4.413A4.413,4.413,0,0,0,40.243,66.8Z"
              transform="translate(-20.38 -38.58)"
              fill="#fac404"
            />
          </g>
          <g transform="matrix(1, 0, 0, 1, -12.67, -6)" filter="url(#Path_18951)">
            <path
              id="Path_18951-2"
              data-name="Path 18951"
              d="M33.684,10.1,30.968,5H27.193l4.6,8.648Z"
              transform="translate(-14.38 1)"
              fill="#ff2300"
            />
          </g>
          <g transform="matrix(1, 0, 0, 1, -12.67, -6)" filter="url(#Path_18952)">
            <path
              id="Path_18952-2"
              data-name="Path 18952"
              d="M47.775,14.629,52.9,5H49.126L44,14.629Z"
              transform="translate(-25.99 1)"
              fill="#ff2300"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};
export const ProficientIcon = ({ width, height }) => {
  return (
    <svg
      id="Group_7080"
      data-name="Group 7080"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}>
      <path
        id="Path_18957"
        data-name="Path 18957"
        d="M30.807,42.574c-.225,0-.441-.009-.666-.017a12.149,12.149,0,0,1-4.115-.985l-15-6.518V41.8a8.253,8.253,0,0,0,1.781,5.264c6.829,8.324,29.294,8.661,35.57-.519a8.28,8.28,0,0,0,1.357-4.676V34.95L35.9,41.433A12.033,12.033,0,0,1,30.807,42.574Z"
        transform="translate(-1.937 -13.167)"
        fill="#21468a"
      />
      <path
        id="Path_18958"
        data-name="Path 18958"
        d="M56.679,22.275a3.767,3.767,0,0,0-2.135-2.42L32.683,10.476a8.956,8.956,0,0,0-7.045-.009L4.054,19.647a4.16,4.16,0,0,0-2.438,2.991A4.073,4.073,0,0,0,2.075,25.5,2.6,2.6,0,0,1,3.5,24.7l20.244-3.881c.035-.009.061-.009.1-.017,1.08-1.331,3.38-2.221,6.085-2.221,3.786,0,6.751,1.746,6.751,3.976s-2.965,3.968-6.751,3.968a10,10,0,0,1-4.374-.925,2.659,2.659,0,0,1-.83.311L8.195,29.078l17.236,7.494a10.323,10.323,0,0,0,3.518.838,10.206,10.206,0,0,0,4.927-.959l20.746-9.724A3.756,3.756,0,0,0,56.679,22.275Z"
        transform="translate(-0.649 -9.75)"
        fill="#21468a"
      />
      <path
        id="Path_18959"
        data-name="Path 18959"
        d="M4.815,36.594,4.728,29.61,25.9,25.573a8.2,8.2,0,0,0,3.9.882c2.87,0,5.022-1.184,5.022-2.247S32.674,21.96,29.8,21.96c-2.723,0-4.789,1.055-5.013,2.066L3.691,28.045a.857.857,0,0,0-.7.864l.1,7.684a3.432,3.432,0,0,0,0,6.647v2.714a.864.864,0,1,0,1.729,0V43.241a3.432,3.432,0,0,0,0-6.647Z"
        transform="translate(-0.51 -11.406)"
        fill="#fff"
      />
    </svg>
  );
};
export const MasterIcon = ({ width, height }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}>
      <g id="Group_7157" data-name="Group 7157" transform="translate(-104.295 -186.29)">
        <g id="Group_7151" data-name="Group 7151" transform="translate(104.295 186.29)">
          <g id="Polygon_70" data-name="Polygon 70" transform="translate(0 0)" fill="#f26e1e">
            <path
              d="M 27.05220794677734 33.64999771118164 L 12.87061882019043 33.64999771118164 C 11.4445686340332 33.64999771118164 10.11647891998291 32.88237762451172 9.404618263244629 31.64670753479004 L 2.304348707199097 19.32170677185059 C 1.594838619232178 18.090087890625 1.594838619232178 16.55989646911621 2.304348707199097 15.32827663421631 L 9.404628753662109 3.003286838531494 C 10.11647891998291 1.767606973648071 11.4445686340332 0.9999969601631165 12.87061882019043 0.9999969601631165 L 27.05220794677734 0.9999969601631165 C 28.47825813293457 0.9999969601631165 29.80634880065918 1.767606973648071 30.51819801330566 3.003286838531494 L 37.61846923828125 15.32828712463379 C 38.32799911499023 16.55990600585938 38.32799911499023 18.090087890625 37.61846923828125 19.32170677185059 L 30.51819801330566 31.64670753479004 C 29.80634880065918 32.88238525390625 28.47825813293457 33.64999771118164 27.05220794677734 33.64999771118164 Z"
              stroke="none"
            />
            <path
              d="M 12.87061882019043 1.999996185302734 C 11.80107879638672 1.999996185302734 10.80500793457031 2.575706481933594 10.2711181640625 3.502466201782227 L 3.170848846435547 15.82745742797852 C 2.638710021972656 16.75116729736328 2.638710021972656 17.89881706237793 3.170848846435547 18.8225269317627 L 10.2711181640625 31.14752769470215 C 10.80500793457031 32.07428741455078 11.80107879638672 32.64999771118164 12.87061882019043 32.64999771118164 L 27.05220794677734 32.64999771118164 C 28.12173843383789 32.64999771118164 29.1178092956543 32.07428741455078 29.65169906616211 31.14752769470215 L 36.75196838378906 18.8225269317627 C 37.28410720825195 17.89881706237793 37.28410720825195 16.75116729736328 36.75196838378906 15.82745742797852 L 29.65169906616211 3.502466201782227 C 29.1178092956543 2.575706481933594 28.12173843383789 1.999996185302734 27.05220794677734 1.999996185302734 L 12.87061882019043 1.999996185302734 M 12.87061882019043 -3.814697265625e-06 L 27.05220794677734 -3.814697265625e-06 C 28.84022903442383 -3.814697265625e-06 30.49215888977051 0.9547882080078125 31.38469886779785 2.504108428955078 L 38.48497009277344 14.82909774780273 C 39.37496948242188 16.3740177154541 39.37496948242188 18.27597618103027 38.48497009277344 19.82088661193848 L 31.38469886779785 32.1458854675293 C 30.49215888977051 33.69520568847656 28.84022903442383 34.64999771118164 27.05220794677734 34.64999771118164 L 12.87061882019043 34.64999771118164 C 11.08259773254395 34.64999771118164 9.430658340454102 33.69520568847656 8.538118362426758 32.1458854675293 L 1.437847137451172 19.82088661193848 C 0.5478401184082031 18.27596664428711 0.5478401184082031 16.3740177154541 1.437847137451172 14.82909774780273 L 8.538118362426758 2.504108428955078 C 9.430667877197266 0.9547882080078125 11.08259773254395 -3.814697265625e-06 12.87061882019043 -3.814697265625e-06 Z"
              stroke="none"
              fill="#ffe87a"
            />
          </g>
        </g>
        <g id="Group_7158" data-name="Group 7158" transform="translate(116.321 193.315)">
          <g id="Group_7077" data-name="Group 7077" transform="translate(0 0)">
            <g id="Group_7075" data-name="Group 7075">
              <path
                id="Path_18960"
                data-name="Path 18960"
                d="M22.225,7.955a.587.587,0,1,1-.926.192c.8-1.309,2.809-3.192,2.873-4.437a1.8,1.8,0,0,0-2.426-1.724c-.032-.319.16-1.022-.319-1.022-.575,0-1.149,0-1.66.032V4.635a.335.335,0,0,1-.16.287.29.29,0,0,1-.319,0l-.67-.447-.7.415a.29.29,0,0,1-.319,0,.335.335,0,0,1-.16-.287V1c-6.193,0-6.544-.223-6.544.287v.7A1.769,1.769,0,0,0,8.5,3.71a3.343,3.343,0,0,0,.83,1.756c1.915,2.49,1.915,2.49,2.011,2.618a.587.587,0,1,1-.894-.128.309.309,0,0,0,0-.447c-.351-.351-.83.287-.83.83a1.232,1.232,0,0,0,2.362.511,10.364,10.364,0,0,0,2.777,3.511.751.751,0,0,1-.511,1.309.929.929,0,0,0-.894.67h6a1.051,1.051,0,0,0-.223-.415.869.869,0,0,0-.67-.287.748.748,0,0,1-.543-.223.735.735,0,0,1,.032-1.085l.415-.383a10,10,0,0,0,2.362-3.16,1.232,1.232,0,0,0,2.362-.511,1.265,1.265,0,0,0-.383-.862C22.353,7.189,21.906,7.668,22.225,7.955Zm-.479-5.267a1.14,1.14,0,0,1,1.756.99c-.032.67-.543,1.149-2.075,3.16A15.67,15.67,0,0,0,21.747,2.688Zm-12.609.99a1.131,1.131,0,0,1,1.756-.99,15.67,15.67,0,0,0,.319,4.15C9.744,4.923,9.169,4.38,9.137,3.678Z"
                transform="translate(-8.498 -0.948)"
                fill="#ffc935"
              />
              <path
                id="Path_18961"
                data-name="Path 18961"
                d="M39.553,4.165V1.1H38.5V4.133l.351-.223C39.107,3.75,39.33,4.037,39.553,4.165Z"
                transform="translate(-28.923 -1.051)"
                fill="#ff0009"
              />
            </g>
            <g id="Group_7076" data-name="Group 7076" transform="translate(3.544 14.063)">
              <rect
                id="Rectangle_4021"
                data-name="Rectangle 4021"
                width="4.98"
                height="1.022"
                transform="translate(1.788 1.437)"
                fill="#fff"
              />
              <path
                id="Path_18962"
                data-name="Path 18962"
                d="M27.549,45H20.207a.606.606,0,0,0-.607.607v3h8.523v-3A.562.562,0,0,0,27.549,45Zm-.543,2.777a.3.3,0,0,1-.319.319H21.068a.3.3,0,0,1-.319-.319v-1.66a.3.3,0,0,1,.319-.319h5.618a.3.3,0,0,1,.319.319v1.66Z"
                transform="translate(-19.6 -45)"
                fill="#ffc935"
              />
            </g>
          </g>
          <g id="Group_7078" data-name="Group 7078" transform="translate(1.469 18.308)">
            <path
              id="Path_18963"
              data-name="Path 18963"
              d="M25.805,60.12a.343.343,0,0,1-.319.319H13.419a.343.343,0,0,1-.319-.319.32.32,0,0,1,.319-.319h.607V58.619a.3.3,0,0,1,.319-.319H24.56a.3.3,0,0,1,.319.319V59.8h.607A.32.32,0,0,1,25.805,60.12Z"
              transform="translate(-13.1 -58.3)"
              fill="#ffc935"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};
export const EliteIcon = ({ width, height }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}>
      <g id="Group_7159" data-name="Group 7159" transform="translate(-104.295 -186.29)">
        <g id="Group_7151" data-name="Group 7151" transform="translate(104.295 186.29)">
          <g id="Polygon_70" data-name="Polygon 70" transform="translate(0 0)" fill="#f1550f">
            <path
              d="M 27.05220794677734 33.64999771118164 L 12.87061882019043 33.64999771118164 C 11.4445686340332 33.64999771118164 10.11647891998291 32.88237762451172 9.404618263244629 31.64670753479004 L 2.304348707199097 19.32170677185059 C 1.594838619232178 18.090087890625 1.594838619232178 16.55989646911621 2.304348707199097 15.32827663421631 L 9.404628753662109 3.003286838531494 C 10.11647891998291 1.767606973648071 11.4445686340332 0.9999969601631165 12.87061882019043 0.9999969601631165 L 27.05220794677734 0.9999969601631165 C 28.47825813293457 0.9999969601631165 29.80634880065918 1.767606973648071 30.51819801330566 3.003286838531494 L 37.61846923828125 15.32828712463379 C 38.32799911499023 16.55990600585938 38.32799911499023 18.090087890625 37.61846923828125 19.32170677185059 L 30.51819801330566 31.64670753479004 C 29.80634880065918 32.88238525390625 28.47825813293457 33.64999771118164 27.05220794677734 33.64999771118164 Z"
              stroke="none"
            />
            <path
              d="M 12.87061882019043 1.999996185302734 C 11.80107879638672 1.999996185302734 10.80500793457031 2.575706481933594 10.2711181640625 3.502466201782227 L 3.170848846435547 15.82745742797852 C 2.638710021972656 16.75116729736328 2.638710021972656 17.89881706237793 3.170848846435547 18.8225269317627 L 10.2711181640625 31.14752769470215 C 10.80500793457031 32.07428741455078 11.80107879638672 32.64999771118164 12.87061882019043 32.64999771118164 L 27.05220794677734 32.64999771118164 C 28.12173843383789 32.64999771118164 29.1178092956543 32.07428741455078 29.65169906616211 31.14752769470215 L 36.75196838378906 18.8225269317627 C 37.28410720825195 17.89881706237793 37.28410720825195 16.75116729736328 36.75196838378906 15.82745742797852 L 29.65169906616211 3.502466201782227 C 29.1178092956543 2.575706481933594 28.12173843383789 1.999996185302734 27.05220794677734 1.999996185302734 L 12.87061882019043 1.999996185302734 M 12.87061882019043 -3.814697265625e-06 L 27.05220794677734 -3.814697265625e-06 C 28.84022903442383 -3.814697265625e-06 30.49215888977051 0.9547882080078125 31.38469886779785 2.504108428955078 L 38.48497009277344 14.82909774780273 C 39.37496948242188 16.3740177154541 39.37496948242188 18.27597618103027 38.48497009277344 19.82088661193848 L 31.38469886779785 32.1458854675293 C 30.49215888977051 33.69520568847656 28.84022903442383 34.64999771118164 27.05220794677734 34.64999771118164 L 12.87061882019043 34.64999771118164 C 11.08259773254395 34.64999771118164 9.430658340454102 33.69520568847656 8.538118362426758 32.1458854675293 L 1.437847137451172 19.82088661193848 C 0.5478401184082031 18.27596664428711 0.5478401184082031 16.3740177154541 1.437847137451172 14.82909774780273 L 8.538118362426758 2.504108428955078 C 9.430667877197266 0.9547882080078125 11.08259773254395 -3.814697265625e-06 12.87061882019043 -3.814697265625e-06 Z"
              stroke="none"
              fill="#ffe87a"
            />
          </g>
        </g>
        <g id="Group_7160" data-name="Group 7160" transform="translate(113.336 196.833)">
          <path
            id="Path_18965"
            data-name="Path 18965"
            d="M25.547,25.593a1.094,1.094,0,0,0-1.511-.32,1.355,1.355,0,0,0-.361,1.841s.182-.651.668-.445c.532.225.211,1.231-.785,1.784A1.936,1.936,0,0,1,20.8,26.631l.562-.416-.253-.7-.6.443.239.663a1.931,1.931,0,0,1-3.27.012c-.543-1-.273-2.022.3-1.926.521.087.324.735.324.735a1.355,1.355,0,0,0,.684-1.748,1.094,1.094,0,0,0-1.446-.541,2.378,2.378,0,0,0-.943-1.6,2.379,2.379,0,0,0-.944,1.6A1.1,1.1,0,0,0,14,23.692a1.355,1.355,0,0,0,.684,1.748s-.2-.647.324-.735c.569-.1.839.925.3,1.926a1.934,1.934,0,0,1-3.29-.039l.245-.68-.6-.443-.253.7.578.428v.007a1.939,1.939,0,0,1-2.758,1.846c-1-.553-1.316-1.559-.785-1.784.486-.206.668.445.668.445a1.354,1.354,0,0,0-.361-1.841,1.1,1.1,0,0,0-1.511.32,2.379,2.379,0,0,0-1.657-.845L9.712,35.4H23.075L27.2,24.748A2.383,2.383,0,0,0,25.547,25.593Z"
            transform="translate(-5.583 -21.548)"
            fill="#f3c603"
          />
          <path
            id="Path_18969"
            data-name="Path 18969"
            d="M0,0,14.785.011l-.725,1.838L.693,1.838Z"
            transform="translate(3.418 11.998)"
            fill="#fff"
            opacity="0.32"
          />
          <path
            id="Path_18970"
            data-name="Path 18970"
            d="M.672,0l.672,2.016A.672.672,0,1,1,0,2.016Z"
            transform="translate(10.138 6.621)"
            fill="#227299"
          />
          <path
            id="Path_18971"
            data-name="Path 18971"
            d="M.514,0l.514,1.541A.514.514,0,1,1,0,1.541Z"
            transform="matrix(0.966, 0.259, -0.259, 0.966, 13.87, 6.621)"
            fill="#227299"
          />
          <path
            id="Path_18972"
            data-name="Path 18972"
            d="M.514,0l.514,1.541A.514.514,0,0,1,0,1.541Z"
            transform="translate(6.421 7.135) rotate(-30)"
            fill="#227299"
          />
        </g>
      </g>
    </svg>
  );
};
export const ScoreIcon = () => {
  return (
    <svg
      id="Award_leaderboard_rank_ranking"
      data-name="Award, leaderboard, rank, ranking"
      xmlns="http://www.w3.org/2000/svg"
      width="59.907"
      height="57.52"
      viewBox="0 0 59.907 57.52">
      <g
        id="Rectangle_3794"
        data-name="Rectangle 3794"
        transform="translate(20.54 32.7)"
        fill="#f8b510"
        stroke="#f8b510"
        stroke-width="2">
        <path
          d="M2,0H16.828a2,2,0,0,1,2,2V24.82a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V2A2,2,0,0,1,2,0Z"
          stroke="none"
        />
        <rect x="1" y="1" width="16.828" height="22.82" rx="1" fill="none" />
      </g>
      <g
        id="Rectangle_3795"
        data-name="Rectangle 3795"
        transform="translate(0 38.692)"
        fill="none"
        stroke="#f8b510"
        stroke-width="2">
        <path
          d="M2,0H16.828a2,2,0,0,1,2,2V18.828a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V2A2,2,0,0,1,2,0Z"
          stroke="none"
        />
        <rect x="1" y="1" width="16.828" height="16.828" rx="1" fill="none" />
      </g>
      <g
        id="Rectangle_3796"
        data-name="Rectangle 3796"
        transform="translate(41.079 44.281)"
        fill="none"
        stroke="#f8b510"
        stroke-width="2">
        <path
          d="M2,0H16.828a2,2,0,0,1,2,2V13.238a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V2A2,2,0,0,1,2,0Z"
          stroke="none"
        />
        <rect x="1" y="1" width="16.828" height="11.238" rx="1" fill="none" />
      </g>
      <path
        id="Path_17587"
        data-name="Path 17587"
        d="M56.409,15.7a1.733,1.733,0,0,0-1.392-1.19l-5.868-.863-2.6-5.311a1.726,1.726,0,0,0-1.58-.974h0a1.74,1.74,0,0,0-1.559.967L40.8,13.617l-5.854.835a1.747,1.747,0,0,0-1.392,1.183,1.726,1.726,0,0,0,.432,1.782l4.225,4.176-1.016,5.826a1.74,1.74,0,0,0,2.52,1.838l5.262-2.77L50.2,29.271a1.7,1.7,0,0,0,.814.2,1.733,1.733,0,0,0,1.712-2.025l-.981-5.833L55.991,17.5A1.747,1.747,0,0,0,56.409,15.7Z"
        transform="translate(-14.772 -7.36)"
        fill="#f8b510"
      />
    </svg>
  );
};
